var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc401Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M438.16,317.22,425,317.5l-6.66.11c-2.23.05-4.46,0-6.69.05h-.45v-.45L411.18,306v-.5h.51l13.24.06c4.41,0,8.82.11,13.24.16h.27V306c0,1.9-.09,3.78-.13,5.65Zm0,0-.15-5.66c0-1.86-.11-3.7-.13-5.53l.28.27c-4.42.05-8.83.16-13.24.16l-13.24.07.49-.5-.05,11.19-.44-.45c2.18,0,4.35,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.38,331.33l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.32,317.22l-13.12.28-6.66.11c-2.23.05-4.46,0-6.7.05H61.4v-.45L61.34,306v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V306c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,331.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.93,331.33l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69,0H426v-.45L426,320.14v-.5h.5l13.24.06c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.12-3.7-.14-5.53l.28.27c-4.42,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.58,138.34l-13.13.28-6.66.11c-2.23.05-4.46,0-6.69.06h-.45v-.45l-.05-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.71-.13-5.54l.28.28c-4.42,0-8.83.15-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.8,152.45l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41.05-8.82.15-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.35,152.45l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.12-3.71-.13-5.54l.27.28c-4.42.05-8.83.15-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.36,0,6.54.05l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.3,216.72l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19V205h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.62,65.37l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41,0-8.82.15-13.24.16l-13.24.06.5-.5-.05,11.19-.45-.44c2.19,0,4.36,0,6.55,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.4,79.48l-13.13.28-6.66.11c-2.23,0-4.46,0-6.69.06h-.45v-.45l-.05-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.86-.11-3.71-.13-5.54l.28.28c-4.42.05-8.83.15-13.24.16l-13.24.06.5-.5-.06,11.19-.44-.44c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.55,65.38l-13.12.28-6.66.12c-2.23,0-4.47,0-6.7,0h-.44v-.45L46.57,54.2v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.14,5.65Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.18-.45-.44c2.18,0,4.36,0,6.55,0l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.83,
    y: 254.71,
    width: 12.87,
    height: 171.16,
    transform: "translate(-189.99 453.12) rotate(-79.74)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.31 320.55 91.37 328.82 93.2 318.72 103.31 320.55",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.47 324.01 107.52 334.38 97.28 332.53 112.23 322.16 122.47 324.01",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.63 327.48 126.67 337.85 116.43 336 131.4 325.63 141.63 327.48",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.79 330.95 145.84 341.32 135.6 339.47 150.55 329.1 160.79 330.95",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.95 334.42 164.99 344.79 154.75 342.94 169.71 332.57 179.95 334.42",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.11 337.89 184.15 348.26 173.92 346.41 188.87 336.04 199.11 337.89",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.27 341.36 203.31 351.73 193.08 349.88 208.03 339.5 218.27 341.36",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "237.42 344.83 222.47 355.2 212.24 353.35 227.19 342.98 237.42 344.83",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.59 348.3 241.63 358.67 231.4 356.81 246.35 346.44 256.59 348.3",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.92 353.09 259.33 361.87 250.55 360.28 260.92 353.09",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.69,
    y: 333.86,
    width: 171.16,
    height: 12.87,
    transform: "translate(-36.99 21.88) rotate(-6.43)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,349.08a.69.69,0,0,1,0,.32.78.78,0,0,1-.16.28.72.72,0,0,1-.25.21.77.77,0,0,1-.3.11.55.55,0,0,1-.41-.13.61.61,0,0,1-.19-.39.71.71,0,0,1,0-.32.78.78,0,0,1,.16-.28.91.91,0,0,1,.24-.2.71.71,0,0,1,.3-.1.53.53,0,0,1,.41.11A.62.62,0,0,1,94.64,349.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.66,346.46l1.6-.18a2.19,2.19,0,0,1,.78.05,1.62,1.62,0,0,1,.58.31,1.53,1.53,0,0,1,.37.52,1.85,1.85,0,0,1,.18.67,3,3,0,0,1-.07,1.12,2.72,2.72,0,0,1-.47.93,2.5,2.5,0,0,1-.78.66,2.77,2.77,0,0,1-1,.33l-1.61.18Zm1.24,3.48a1.3,1.3,0,0,0,.56-.2,1.34,1.34,0,0,0,.4-.42,1.59,1.59,0,0,0,.23-.57,2.35,2.35,0,0,0,0-.65,1.15,1.15,0,0,0-.29-.69.77.77,0,0,0-.66-.2l-.57.07L99.34,350Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.46,350.38a1.63,1.63,0,0,1-.74-.07,1.58,1.58,0,0,1-.58-.36,1.87,1.87,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.22,2.22,0,0,1,0-.68,3.89,3.89,0,0,1,.21-.66,2.78,2.78,0,0,1,.37-.59,2.9,2.9,0,0,1,.49-.5,3.37,3.37,0,0,1,.61-.36,2.55,2.55,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2.36,2.36,0,0,1,.19.69,2.29,2.29,0,0,1-.11,1,2.81,2.81,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.3,2.3,0,0,1,104.46,350.38Zm.1-.94a1.2,1.2,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,2.32,2.32,0,0,0,.22-.57,2.05,2.05,0,0,0,0-.6,1.51,1.51,0,0,0-.1-.38,1.05,1.05,0,0,0-.18-.31.7.7,0,0,0-.29-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.56.22,1.4,1.4,0,0,0-.4.44,1.78,1.78,0,0,0-.22.57,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.09.39,1.08,1.08,0,0,0,.19.31.88.88,0,0,0,.29.2A.91.91,0,0,0,104.56,349.44Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,345.29l.81-.1,1.64,2.48.25-2.69,1-.12-.45,4.59-.82.09L110,347.13l-.25,2.62-1,.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.12,349.18a1.63,1.63,0,0,1-.74-.07,1.5,1.5,0,0,1-.58-.36,1.87,1.87,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.21,2.21,0,0,1,0-.68,3.63,3.63,0,0,1,.21-.66,2.78,2.78,0,0,1,.37-.59,2.58,2.58,0,0,1,.49-.5,3.37,3.37,0,0,1,.61-.36,2.55,2.55,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2.28,2.28,0,0,1,.08,1.69,2.91,2.91,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.3,2.3,0,0,1,115.12,349.18Zm.1-.94a1.11,1.11,0,0,0,.57-.23,1.41,1.41,0,0,0,.39-.45,2,2,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.51,1.51,0,0,0-.1-.38,1.05,1.05,0,0,0-.18-.31.84.84,0,0,0-.29-.2.93.93,0,0,0-.38,0,1.28,1.28,0,0,0-.57.22,1.67,1.67,0,0,0-.39.45,1.78,1.78,0,0,0-.22.57,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.09.39,1.08,1.08,0,0,0,.19.31.73.73,0,0,0,.29.19A.77.77,0,0,0,115.22,348.24Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,345.12l-1.28.14.09-.93,3.58-.4-.08.93-1.28.14-.36,3.66-1,.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43,348.13a1.41,1.41,0,0,1-.72-.08,1.69,1.69,0,0,1-.58-.37,1.92,1.92,0,0,1-.39-.57,2.42,2.42,0,0,1-.19-.7,2.22,2.22,0,0,1,0-.63,2.94,2.94,0,0,1,.19-.64,2.7,2.7,0,0,1,.35-.59,2.9,2.9,0,0,1,.48-.51,3.42,3.42,0,0,1,.61-.37,2.39,2.39,0,0,1,.72-.19,1.68,1.68,0,0,1,1,.16,1.29,1.29,0,0,1,.59.65l-.85.66a.67.67,0,0,0-.14-.28.69.69,0,0,0-.22-.17.73.73,0,0,0-.25-.08h-.27a1.09,1.09,0,0,0-.57.22,1.49,1.49,0,0,0-.39.44,2,2,0,0,0-.21.57,1.59,1.59,0,0,0,0,.57,1.37,1.37,0,0,0,.09.4,1.1,1.1,0,0,0,.2.31.72.72,0,0,0,.29.2.74.74,0,0,0,.37.05,1,1,0,0,0,.27-.07,1.16,1.16,0,0,0,.27-.14,1.27,1.27,0,0,0,.25-.22,1.08,1.08,0,0,0,.19-.31l.8.41a1.76,1.76,0,0,1-.33.49,2.17,2.17,0,0,1-.48.38,2.73,2.73,0,0,1-.54.27A2.3,2.3,0,0,1,124.43,348.13Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.75,347.83l.45-4.58,1.92-.22a1.12,1.12,0,0,1,.49.05,1.05,1.05,0,0,1,.37.25,1.31,1.31,0,0,1,.27.38,1.43,1.43,0,0,1,.13.46,1.78,1.78,0,0,1,0,.46,2.51,2.51,0,0,1-.16.46,2.19,2.19,0,0,1-.26.41,1.65,1.65,0,0,1-.37.33l.77,1.6-1.17.13-.66-1.39-.58.07-.14,1.47Zm2.13-2.61a.38.38,0,0,0,.18-.09.45.45,0,0,0,.15-.18.67.67,0,0,0,.1-.26,1,1,0,0,0,0-.3.58.58,0,0,0-.12-.32.26.26,0,0,0-.23-.1l-.83.09-.12,1.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.7,347.2a1.63,1.63,0,0,1-.74-.07,1.5,1.5,0,0,1-.58-.36,2,2,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.21,2.21,0,0,1,0-.68,3.63,3.63,0,0,1,.21-.66,2.78,2.78,0,0,1,.37-.59,2.58,2.58,0,0,1,.49-.5,2.88,2.88,0,0,1,.61-.36,2.55,2.55,0,0,1,.67-.18,1.5,1.5,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2.22,2.22,0,0,1,.19.68,2.32,2.32,0,0,1-.11,1,2.91,2.91,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.3,2.3,0,0,1,132.7,347.2Zm.1-.94a1.11,1.11,0,0,0,.57-.23,1.41,1.41,0,0,0,.39-.45A2,2,0,0,0,134,345a2,2,0,0,0,0-.59,1.41,1.41,0,0,0-.1-.38,1.05,1.05,0,0,0-.18-.31.84.84,0,0,0-.29-.2.93.93,0,0,0-.38,0,1.28,1.28,0,0,0-.57.22,1.53,1.53,0,0,0-.39.45,1.82,1.82,0,0,0-.22.56,2.05,2.05,0,0,0,0,.6,1.51,1.51,0,0,0,.09.38,1.13,1.13,0,0,0,.19.32.73.73,0,0,0,.29.19A.77.77,0,0,0,132.8,346.26Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,346.73a3.28,3.28,0,0,1-.94,0,2.36,2.36,0,0,1-.83-.32l.54-1a.49.49,0,0,0,.14.11,1.4,1.4,0,0,0,.3.14,2.1,2.1,0,0,0,.42.12,1.55,1.55,0,0,0,.48,0,.63.63,0,0,0,.42-.16.39.39,0,0,0,.09-.3.26.26,0,0,0-.09-.17.68.68,0,0,0-.21-.11A1.71,1.71,0,0,0,137,345l-.36-.08a1.73,1.73,0,0,1-.72-.31.79.79,0,0,1-.29-.57,1.53,1.53,0,0,1,.08-.74,1.64,1.64,0,0,1,.37-.59,2,2,0,0,1,.58-.4,2.35,2.35,0,0,1,.7-.2,2.16,2.16,0,0,1,.44,0,1.76,1.76,0,0,1,.4.07,1.9,1.9,0,0,1,.36.12,2.09,2.09,0,0,1,.3.14l-.54.93s-.05,0-.11-.08l-.25-.12-.35-.1a1.6,1.6,0,0,0-.38,0,.67.67,0,0,0-.4.16.42.42,0,0,0-.11.34.31.31,0,0,0,.23.26c.14,0,.33.09.58.14a3,3,0,0,1,.45.12,1.16,1.16,0,0,1,.37.18.81.81,0,0,1,.25.27,1.05,1.05,0,0,1,.12.39,1.51,1.51,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.79,1.79,0,0,1-.6.35A2.71,2.71,0,0,1,137,346.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.72,346.31a3.28,3.28,0,0,1-.94,0A2.36,2.36,0,0,1,139,346l.54-1a.49.49,0,0,0,.14.11,1.4,1.4,0,0,0,.3.14,2.1,2.1,0,0,0,.42.12,1.53,1.53,0,0,0,.48,0,.58.58,0,0,0,.41-.16.36.36,0,0,0,.1-.3.26.26,0,0,0-.09-.17.68.68,0,0,0-.21-.11,1.71,1.71,0,0,0-.29-.08l-.36-.08a1.87,1.87,0,0,1-.72-.31.76.76,0,0,1-.29-.57,1.52,1.52,0,0,1,.08-.74,1.64,1.64,0,0,1,.37-.59,1.87,1.87,0,0,1,.58-.4,2.35,2.35,0,0,1,.7-.2,2.16,2.16,0,0,1,.44,0,1.76,1.76,0,0,1,.4.07,1.9,1.9,0,0,1,.36.12l.3.14-.54.93s0,0-.11-.08a1.62,1.62,0,0,0-.26-.12,2.31,2.31,0,0,0-.34-.1,1.2,1.2,0,0,0-.38,0,.67.67,0,0,0-.4.16.41.41,0,0,0-.11.34.31.31,0,0,0,.23.26c.14,0,.33.09.58.14a3,3,0,0,1,.45.12,1.16,1.16,0,0,1,.37.18.81.81,0,0,1,.25.27,1.05,1.05,0,0,1,.12.39,1.62,1.62,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.89,1.89,0,0,1-.6.35A2.71,2.71,0,0,1,140.72,346.31Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,343.29a.85.85,0,0,1,0,.32,1,1,0,0,1-.16.29,1.27,1.27,0,0,1-.25.21.88.88,0,0,1-.3.1.49.49,0,0,1-.41-.12.62.62,0,0,1-.2-.39.69.69,0,0,1,0-.32.85.85,0,0,1,.16-.28.72.72,0,0,1,.25-.21.63.63,0,0,1,.3-.1.49.49,0,0,1,.41.12A.58.58,0,0,1,146,343.29Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,340.68l1.6-.18a1.81,1.81,0,0,1,.78.05,1.41,1.41,0,0,1,.58.31,1.37,1.37,0,0,1,.37.51,2.15,2.15,0,0,1,.19.67,3.18,3.18,0,0,1-.08,1.12,2.55,2.55,0,0,1-.47.93,2.67,2.67,0,0,1-.78.67,2.7,2.7,0,0,1-1,.32l-1.6.18Zm1.24,3.47a1.18,1.18,0,0,0,.56-.2,1.49,1.49,0,0,0,.41-.42,1.78,1.78,0,0,0,.22-.57,1.72,1.72,0,0,0,0-.64,1.1,1.1,0,0,0-.29-.69.74.74,0,0,0-.66-.2l-.57.06-.26,2.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.84,344.59a1.63,1.63,0,0,1-.74-.07,1.58,1.58,0,0,1-.58-.36,1.76,1.76,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.22,2.22,0,0,1,0-.68,3.89,3.89,0,0,1,.21-.66,2.78,2.78,0,0,1,.37-.59,2.9,2.9,0,0,1,.49-.5,3.37,3.37,0,0,1,.61-.36,2.55,2.55,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2.36,2.36,0,0,1,.19.69,2.29,2.29,0,0,1-.11,1,2.81,2.81,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.3,2.3,0,0,1,155.84,344.59Zm.1-.94a1.2,1.2,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,2.32,2.32,0,0,0,.22-.57,2.05,2.05,0,0,0,0-.6,1.64,1.64,0,0,0-.1-.38,1.05,1.05,0,0,0-.18-.31.7.7,0,0,0-.29-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.56.22,1.4,1.4,0,0,0-.4.44,1.78,1.78,0,0,0-.22.57,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.09.39,1.08,1.08,0,0,0,.19.31.88.88,0,0,0,.29.2A.78.78,0,0,0,155.94,343.65Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.48,339.5l.81-.09,1.63,2.47.26-2.69,1-.11-.45,4.58-.82.09-1.63-2.41-.26,2.62-1,.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,343.39a1.66,1.66,0,0,1-.75-.07,1.54,1.54,0,0,1-.57-.36,1.63,1.63,0,0,1-.4-.56,2.72,2.72,0,0,1-.19-.69,2.59,2.59,0,0,1,0-.68,2.67,2.67,0,0,1,.21-.66,3.21,3.21,0,0,1,.36-.59,3,3,0,0,1,.5-.5,3.67,3.67,0,0,1,.6-.36,2.62,2.62,0,0,1,.68-.18,1.59,1.59,0,0,1,.73.08,1.61,1.61,0,0,1,.58.35,1.92,1.92,0,0,1,.39.57,2.36,2.36,0,0,1,.19.69,2.45,2.45,0,0,1-.11,1,2.81,2.81,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.3,2.3,0,0,1,166.5,343.39Zm.09-.94a1.2,1.2,0,0,0,.57-.22,1.9,1.9,0,0,0,.4-.45,2,2,0,0,0,.21-.57,1.76,1.76,0,0,0,0-.6,1.24,1.24,0,0,0-.09-.38,1.08,1.08,0,0,0-.19-.31.67.67,0,0,0-.28-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.57.22,1.68,1.68,0,0,0-.4.44,1.77,1.77,0,0,0-.21.57,1.7,1.7,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39,1.08,1.08,0,0,0,.19.31,1,1,0,0,0,.28.2A.78.78,0,0,0,166.59,342.45Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,339.33l-1.28.14.09-.93,3.59-.4-.09.93-1.27.14-.36,3.65-1,.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.81,342.34a1.46,1.46,0,0,1-.73-.08,1.75,1.75,0,0,1-.57-.37,1.92,1.92,0,0,1-.39-.57,2.42,2.42,0,0,1-.19-.7,2.22,2.22,0,0,1,0-.63,2.94,2.94,0,0,1,.19-.64,2.36,2.36,0,0,1,.35-.59,2.9,2.9,0,0,1,.48-.51,3.1,3.1,0,0,1,.61-.37,2.39,2.39,0,0,1,.72-.19,1.68,1.68,0,0,1,1,.16,1.29,1.29,0,0,1,.59.65l-.85.66a.81.81,0,0,0-.14-.28.69.69,0,0,0-.22-.17.79.79,0,0,0-.26-.08h-.26a1,1,0,0,0-.57.22,1.49,1.49,0,0,0-.39.44,2,2,0,0,0-.21.57,1.6,1.6,0,0,0,0,.57,1.8,1.8,0,0,0,.1.4,1.1,1.1,0,0,0,.2.31.72.72,0,0,0,.29.2.74.74,0,0,0,.37,0,1.08,1.08,0,0,0,.27-.07,1.16,1.16,0,0,0,.27-.14,1.27,1.27,0,0,0,.25-.22,1,1,0,0,0,.19-.31l.8.42a2.18,2.18,0,0,1-.81.86,2.73,2.73,0,0,1-.54.27A2.3,2.3,0,0,1,175.81,342.34Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.11,342l.45-4.58,1.92-.22a.94.94,0,0,1,.48.06,1,1,0,0,1,.38.24,1.46,1.46,0,0,1,.27.38,1.49,1.49,0,0,1,.12.46,1.25,1.25,0,0,1,0,.47,1.83,1.83,0,0,1-.15.45,1.62,1.62,0,0,1-.27.41,1.42,1.42,0,0,1-.36.33l.76,1.6-1.16.13-.66-1.39-.58.07-.14,1.48Zm2.13-2.61a.48.48,0,0,0,.18-.08.58.58,0,0,0,.15-.19.93.93,0,0,0,.1-.25,1,1,0,0,0,0-.3.62.62,0,0,0-.12-.33.26.26,0,0,0-.23-.1l-.83.09-.12,1.26Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,341.41a1.78,1.78,0,0,1-.74-.07,1.66,1.66,0,0,1-.58-.36,2,2,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.21,2.21,0,0,1,0-.68,2.54,2.54,0,0,1,.21-.66,3.08,3.08,0,0,1,.36-.6,2.9,2.9,0,0,1,.5-.49,2.28,2.28,0,0,1,.6-.36,2,2,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.07,1.68,1.68,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.09,2.09,0,0,1,.19.69,2.49,2.49,0,0,1-.1,1,3.13,3.13,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.48,2.48,0,0,1,184.1,341.41Zm.1-1a1,1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,1.78,1.78,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.59,1.59,0,0,0-.09-.39,1,1,0,0,0-.19-.3.69.69,0,0,0-.28-.2,1,1,0,0,0-.39,0,1.2,1.2,0,0,0-.56.22,1.44,1.44,0,0,0-.4.45,2.11,2.11,0,0,0-.22.56,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39.94.94,0,0,0,.18.31.72.72,0,0,0,.29.2A.68.68,0,0,0,184.2,340.46Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.36,340.94a3,3,0,0,1-.94,0,2.36,2.36,0,0,1-.83-.32l.54-1a.49.49,0,0,0,.14.11,1.4,1.4,0,0,0,.3.14,2.1,2.1,0,0,0,.42.12,1.55,1.55,0,0,0,.48,0,.63.63,0,0,0,.42-.16.39.39,0,0,0,.09-.3.26.26,0,0,0-.09-.17.68.68,0,0,0-.21-.11,1.71,1.71,0,0,0-.29-.08l-.36-.08a1.86,1.86,0,0,1-.72-.31.79.79,0,0,1-.29-.56,1.69,1.69,0,0,1,.08-.75,1.9,1.9,0,0,1,.37-.59,2.21,2.21,0,0,1,.58-.4,2.35,2.35,0,0,1,.7-.2h.44a2.38,2.38,0,0,1,.4.07,1.9,1.9,0,0,1,.36.12l.3.14-.54.93a.49.49,0,0,0-.11-.08l-.25-.12a1.79,1.79,0,0,0-.35-.09,1.15,1.15,0,0,0-.37,0,.64.64,0,0,0-.4.16.42.42,0,0,0-.12.34.31.31,0,0,0,.23.26c.14,0,.33.09.58.14a3.09,3.09,0,0,1,.46.12,1.11,1.11,0,0,1,.36.18.81.81,0,0,1,.25.27,1.12,1.12,0,0,1,.12.39,1.51,1.51,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.79,1.79,0,0,1-.6.35A2.34,2.34,0,0,1,188.36,340.94Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.11,340.52a3.31,3.31,0,0,1-.94,0,2.45,2.45,0,0,1-.83-.33l.55-1a.39.39,0,0,0,.13.11,1.29,1.29,0,0,0,.31.14,2.22,2.22,0,0,0,.41.11,1.55,1.55,0,0,0,.48,0,.66.66,0,0,0,.42-.16.32.32,0,0,0,.09-.3.2.2,0,0,0-.09-.17.75.75,0,0,0-.2-.11l-.3-.08-.36-.08a2,2,0,0,1-.72-.31.83.83,0,0,1-.29-.57,1.64,1.64,0,0,1,.08-.74,1.66,1.66,0,0,1,.38-.59,2,2,0,0,1,.57-.4,2.23,2.23,0,0,1,.7-.2,1.62,1.62,0,0,1,.44,0,1.85,1.85,0,0,1,.41.07,2.06,2.06,0,0,1,.35.12,2.09,2.09,0,0,1,.3.14l-.53.93a.26.26,0,0,0-.12-.08,1.47,1.47,0,0,0-.25-.12,2.75,2.75,0,0,0-.34-.1,1.21,1.21,0,0,0-.38,0,.64.64,0,0,0-.4.16.38.38,0,0,0-.11.34.29.29,0,0,0,.22.25,4.27,4.27,0,0,0,.58.15,4.46,4.46,0,0,1,.46.11,1.51,1.51,0,0,1,.36.18.91.91,0,0,1,.25.27.94.94,0,0,1,.13.4,1.62,1.62,0,0,1-.09.78,1.49,1.49,0,0,1-.39.56,1.85,1.85,0,0,1-.59.35A2.79,2.79,0,0,1,192.11,340.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,337.5a.58.58,0,0,1,0,.32.83.83,0,0,1-.16.29,1,1,0,0,1-.25.21.88.88,0,0,1-.3.1.47.47,0,0,1-.41-.13.61.61,0,0,1-.19-.39.89.89,0,0,1,0-.32,1.56,1.56,0,0,1,.16-.28,1,1,0,0,1,.25-.2.63.63,0,0,1,.3-.1.49.49,0,0,1,.41.12A.52.52,0,0,1,197.38,337.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.41,334.89l1.6-.18a1.81,1.81,0,0,1,.78.05,1.42,1.42,0,0,1,.57.3,1.52,1.52,0,0,1,.38.52,2.45,2.45,0,0,1,.18.67,2.77,2.77,0,0,1-.08,1.12,2.54,2.54,0,0,1-.46.93,2.67,2.67,0,0,1-.78.67,2.75,2.75,0,0,1-1,.32l-1.6.18Zm1.24,3.47a1.18,1.18,0,0,0,.56-.2,1.46,1.46,0,0,0,.4-.42,1.8,1.8,0,0,0,.23-.57,2.33,2.33,0,0,0,0-.65,1.1,1.1,0,0,0-.3-.68.7.7,0,0,0-.65-.2l-.57.06-.27,2.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,338.81a1.63,1.63,0,0,1-.74-.08,1.52,1.52,0,0,1-.57-.35,1.78,1.78,0,0,1-.4-.57,2.2,2.2,0,0,1-.19-.69,2.55,2.55,0,0,1,.24-1.33,3.67,3.67,0,0,1,.36-.6,2.9,2.9,0,0,1,.5-.49,2.65,2.65,0,0,1,.6-.36,2,2,0,0,1,.68-.18,1.59,1.59,0,0,1,.73.07,1.5,1.5,0,0,1,.58.36,1.87,1.87,0,0,1,.39.56,2.72,2.72,0,0,1,.19.69,2.5,2.5,0,0,1-.11,1,3,3,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.43,2.43,0,0,1,207.19,338.81Zm.1-.95a1.1,1.1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,1.73,1.73,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.24,1.24,0,0,0-.09-.39,1.08,1.08,0,0,0-.19-.31.77.77,0,0,0-.28-.19.78.78,0,0,0-.38,0,1.2,1.2,0,0,0-.57.22,1.53,1.53,0,0,0-.4.44,2,2,0,0,0-.21.57,1.71,1.71,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39,1,1,0,0,0,.19.31.63.63,0,0,0,.28.2A.68.68,0,0,0,207.29,337.86Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.85,333.71l.81-.09,1.64,2.47.26-2.69,1-.11-.44,4.58-.82.09-1.64-2.41-.25,2.63-1,.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.88,337.6a1.63,1.63,0,0,1-.74-.07,1.58,1.58,0,0,1-.58-.36,1.87,1.87,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2,2,0,0,1,0-.68,2.54,2.54,0,0,1,.21-.66,2.39,2.39,0,0,1,.36-.59,2.63,2.63,0,0,1,.5-.5,3,3,0,0,1,.6-.36,2.55,2.55,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2.38,2.38,0,0,1,.19.68,2.32,2.32,0,0,1-.11,1,2.63,2.63,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.3,2.3,0,0,1,217.88,337.6Zm.1-.94a1.11,1.11,0,0,0,.57-.23,1.41,1.41,0,0,0,.39-.45,2,2,0,0,0,.22-.57,2,2,0,0,0,0-.59,2.11,2.11,0,0,0-.09-.38,1.35,1.35,0,0,0-.19-.31.7.7,0,0,0-.29-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.56.22,1.4,1.4,0,0,0-.4.44,2,2,0,0,0-.22.57,2,2,0,0,0,0,.59,2.23,2.23,0,0,0,.09.39,1.08,1.08,0,0,0,.19.31.81.81,0,0,0,.29.19A.78.78,0,0,0,218,336.66Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.53,333.54l-1.28.14.09-.93,3.59-.4-.09.93-1.27.14-.36,3.66-1,.11Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.2,336.55a1.59,1.59,0,0,1-.73-.08,1.56,1.56,0,0,1-.57-.37,1.92,1.92,0,0,1-.39-.57,2.14,2.14,0,0,1-.19-.7,2,2,0,0,1,0-.64,2.52,2.52,0,0,1,.19-.63,2.66,2.66,0,0,1,.34-.59,3,3,0,0,1,.49-.51,3.1,3.1,0,0,1,.61-.37,2.39,2.39,0,0,1,.72-.19,1.68,1.68,0,0,1,1,.16,1.33,1.33,0,0,1,.59.65l-.85.66a1,1,0,0,0-.15-.29.65.65,0,0,0-.21-.16.79.79,0,0,0-.26-.08h-.26a1.2,1.2,0,0,0-.57.22,1.67,1.67,0,0,0-.39.45,1.84,1.84,0,0,0-.25,1.14,1.59,1.59,0,0,0,.1.39,1,1,0,0,0,.2.32.69.69,0,0,0,.28.2.78.78,0,0,0,.37.05,1.34,1.34,0,0,0,.27-.07.87.87,0,0,0,.27-.14,1,1,0,0,0,.25-.22,1.1,1.1,0,0,0,.2-.31l.8.41a2,2,0,0,1-.34.49,2.12,2.12,0,0,1-.47.38,2.73,2.73,0,0,1-.54.27A2.42,2.42,0,0,1,227.2,336.55Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.51,336.25l.45-4.58,1.92-.22a1.07,1.07,0,0,1,.86.3,1.12,1.12,0,0,1,.26.38,1.22,1.22,0,0,1,.13.46,1.5,1.5,0,0,1,0,.47,2,2,0,0,1-.15.45,1.82,1.82,0,0,1-.27.41,1.61,1.61,0,0,1-.36.33l.76,1.6-1.16.13-.66-1.39-.59.07-.14,1.48Zm2.13-2.61a.48.48,0,0,0,.18-.08.58.58,0,0,0,.15-.19,1.45,1.45,0,0,0,.1-.25,1.06,1.06,0,0,0,0-.31.62.62,0,0,0-.13-.32.23.23,0,0,0-.22-.1l-.83.09-.12,1.25Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.46,335.62a1.63,1.63,0,0,1-.74-.07,1.66,1.66,0,0,1-.58-.36,1.87,1.87,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.21,2.21,0,0,1,0-.68,2.54,2.54,0,0,1,.21-.66,2.74,2.74,0,0,1,.36-.59,2.63,2.63,0,0,1,.5-.5,2.58,2.58,0,0,1,.6-.36,2.55,2.55,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.08,1.65,1.65,0,0,1,.57.35,1.92,1.92,0,0,1,.39.57,2,2,0,0,1,.19.68,2.47,2.47,0,0,1-.1,1,3.13,3.13,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.34,2.34,0,0,1,235.46,335.62Zm.1-.94a1.11,1.11,0,0,0,.57-.23,1.41,1.41,0,0,0,.39-.45,1.78,1.78,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.51,1.51,0,0,0-.09-.38,1.08,1.08,0,0,0-.19-.31.75.75,0,0,0-.29-.2.91.91,0,0,0-.38,0,1.2,1.2,0,0,0-.56.22,1.43,1.43,0,0,0-.4.45,2,2,0,0,0-.22.57,2,2,0,0,0,0,.59,1.72,1.72,0,0,0,.1.39,1.05,1.05,0,0,0,.18.31.81.81,0,0,0,.29.19A.78.78,0,0,0,235.56,334.68Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.74,335.15a3,3,0,0,1-1,0,2.31,2.31,0,0,1-.82-.32l.54-1a.39.39,0,0,0,.13.11,1.29,1.29,0,0,0,.31.14,2.1,2.1,0,0,0,.42.12,1.53,1.53,0,0,0,.48,0,.58.58,0,0,0,.41-.16.36.36,0,0,0,.1-.3.26.26,0,0,0-.09-.17.82.82,0,0,0-.21-.11l-.3-.08-.35-.08a1.84,1.84,0,0,1-.73-.31.83.83,0,0,1-.29-.56,1.56,1.56,0,0,1,.09-.75,1.73,1.73,0,0,1,.37-.59,2.16,2.16,0,0,1,.57-.4,2.53,2.53,0,0,1,.7-.2h.44a2.5,2.5,0,0,1,.41.07,1.8,1.8,0,0,1,.35.12l.3.14-.53.93-.12-.08a1.47,1.47,0,0,0-.25-.12,1.53,1.53,0,0,0-.34-.09,1.22,1.22,0,0,0-.38,0,.64.64,0,0,0-.4.16.39.39,0,0,0-.11.34.29.29,0,0,0,.23.26l.57.14a2.8,2.8,0,0,1,.46.12,1.16,1.16,0,0,1,.37.18.93.93,0,0,1,.25.27,1.12,1.12,0,0,1,.12.39,1.62,1.62,0,0,1-.09.78,1.49,1.49,0,0,1-.39.56,1.85,1.85,0,0,1-.59.35A2.34,2.34,0,0,1,239.74,335.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,334.73a3,3,0,0,1-.94,0,2.44,2.44,0,0,1-.83-.32l.54-1a.49.49,0,0,0,.14.11,1.4,1.4,0,0,0,.3.14,2.32,2.32,0,0,0,.42.12,1.55,1.55,0,0,0,.48,0,.63.63,0,0,0,.42-.16.35.35,0,0,0,.09-.3.26.26,0,0,0-.09-.17.75.75,0,0,0-.2-.11l-.3-.08-.36-.08a1.86,1.86,0,0,1-.72-.31.83.83,0,0,1-.29-.56,1.69,1.69,0,0,1,.08-.75,1.9,1.9,0,0,1,.37-.59,2.39,2.39,0,0,1,.58-.4,2.44,2.44,0,0,1,.7-.2h.44a2.38,2.38,0,0,1,.4.07,1.9,1.9,0,0,1,.36.12l.3.14-.53.93-.12-.08-.25-.12a1.69,1.69,0,0,0-.34-.09,1.23,1.23,0,0,0-.38,0,.64.64,0,0,0-.4.16.39.39,0,0,0-.11.34.28.28,0,0,0,.22.26c.14,0,.33.09.58.14a2.8,2.8,0,0,1,.46.12,1,1,0,0,1,.36.18.72.72,0,0,1,.25.27.81.81,0,0,1,.12.39,1.51,1.51,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.85,1.85,0,0,1-.59.35A2.9,2.9,0,0,1,243.47,334.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.75,331.72a.7.7,0,0,1,0,.32,1.12,1.12,0,0,1-.16.28,1.27,1.27,0,0,1-.25.21.88.88,0,0,1-.3.1.49.49,0,0,1-.41-.12.56.56,0,0,1-.19-.39.69.69,0,0,1,0-.32.85.85,0,0,1,.16-.28,1,1,0,0,1,.25-.21.76.76,0,0,1,.3-.1.49.49,0,0,1,.41.12A.56.56,0,0,1,248.75,331.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.78,329.1l1.6-.18a1.75,1.75,0,0,1,.77.05,1.41,1.41,0,0,1,.58.31,1.48,1.48,0,0,1,.38.51,2.45,2.45,0,0,1,.18.67,3,3,0,0,1-.08,1.12,2.62,2.62,0,0,1-2.28,1.92l-1.6.18Zm1.24,3.47a1.22,1.22,0,0,0,.56-.2,1.46,1.46,0,0,0,.4-.42,1.8,1.8,0,0,0,.23-.57,2,2,0,0,0,0-.64,1.1,1.1,0,0,0-.29-.69.73.73,0,0,0-.65-.2l-.57.06-.27,2.73Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.58,333a1.63,1.63,0,0,1-.74-.08,1.8,1.8,0,0,1-.58-.35,1.92,1.92,0,0,1-.39-.57,2.2,2.2,0,0,1-.19-.69,2.55,2.55,0,0,1,.24-1.33,3.67,3.67,0,0,1,.36-.6,3,3,0,0,1,.5-.5,2.55,2.55,0,0,1,.6-.35,2.3,2.3,0,0,1,.68-.19,1.6,1.6,0,0,1,.73.08,1.58,1.58,0,0,1,.58.36,1.68,1.68,0,0,1,.38.56,2.09,2.09,0,0,1,.19.69,2.34,2.34,0,0,1-.1,1,3.26,3.26,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.48,2.48,0,0,1,258.58,333Zm.1-.95a1.1,1.1,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,1.73,1.73,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.24,1.24,0,0,0-.09-.39,1.08,1.08,0,0,0-.19-.31.77.77,0,0,0-.28-.19.83.83,0,0,0-.39,0,1.1,1.1,0,0,0-.56.22,1.53,1.53,0,0,0-.4.44,2,2,0,0,0-.21.57,1.71,1.71,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39,1.08,1.08,0,0,0,.19.31.72.72,0,0,0,.28.2A.78.78,0,0,0,258.68,332.07Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.84,
    y: 272.91,
    width: 6.23,
    height: 146.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.26 424.09 65.64 424.09 87.83 419.37 94.07 419.37 116.26 424.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.32,
    y: 272.91,
    width: 6.23,
    height: 146.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.74 424.09 235.13 424.09 257.31 419.37 263.56 419.37 285.74 424.09",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-75"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 353.53,
    cy: 457.45,
    rx: 110.6,
    ry: 9.76,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.33,400.94c-3.33.12-7.05.31-9.81-1.85-2.55-2-4.83-5-4.49-8.39.09-1,.32-1.58,1.36-1.16,1.59.63,2.82,2.39,3.92,3.62a33.74,33.74,0,0,0,4.63,4.39c1.19.91,2.46,1.69,3.67,2.58.16.1.31.22.46.33l.17.13h.1a.17.17,0,0,1,.13.08l0,.05A.18.18,0,0,1,230.33,400.94Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5,400.72c-2.93-.05-6.1.09-8.44-1.9a13.78,13.78,0,0,1-2.73-3.31c-.34-.55-1.35-2.2-.93-2.85.76-1.19,4.26,3.64,4.74,4.1a14.35,14.35,0,0,0,6.47,3.37c.16.1.31.22.46.33a15.61,15.61,0,0,1-4.86-1.87c-2.09-1.24-3.24-3.07-4.87-4.79-.35-.37-1.41-1.61-1.81-.84-.27.51.71,2.12.92,2.47a13.47,13.47,0,0,0,2.58,3.14c2.34,2.05,5.49,2,8.44,2.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.17,403c0,.13,0,.25-.08.38v0a.11.11,0,0,1-.06.07.16.16,0,0,1-.18-.07.11.11,0,0,1,0-.08s0,0,0-.05l0-.12h0s0,0,0,0c-.59-2.2-.82-4.5-1.45-6.71s-1.33-4.17-1.76-6.32c-.27-1.36-1.21-8.17,1.79-7.32,1.33.38,2.24,2.3,2.74,3.45a14,14,0,0,1,1.11,4.89C234.54,395.22,233,399,232.17,403Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.13,394.5a15.9,15.9,0,0,0-.48-4.61c-.13-.53-.78-3-1.63-3-.55,0-.64,1.12-.69,1.48a14.27,14.27,0,0,0,.6,4.53A63.36,63.36,0,0,1,232,402c0,.19-.06.39-.08.58s0,.32-.06.48a1,1,0,0,0,0,.17s0,.08,0,.13a.14.14,0,0,0,.18.06c0-.12,0-.24.05-.37,0,.11,0,.2,0,.31h0c0-.11,0-.22.07-.32s0-.05,0-.07c0-.17,0-.34,0-.51A66.94,66.94,0,0,0,233.13,394.5Zm-1,6.88c-.08-1.79-.26-3.57-.51-5.34-.2-1.42-.47-2.83-.77-4.24a14.06,14.06,0,0,1-.38-2.41c0-.62.06-2.92,1.24-1.49.86,1,1.06,3.23,1.17,4.49a23.92,23.92,0,0,1-.09,4.23C232.62,398.21,232.36,399.79,232.12,401.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,412.13h0l-.12,0c-3-.16-7.12.13-9.66-1.89-1.87-1.49-3.71-4.43-3.12-6.93.68-2.82,4.48.56,5.49,1.37A93.17,93.17,0,0,1,234,412l0,0h0S234,412.12,234,412.13Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.08,412c-.18-.11-.36-.21-.53-.33q-3-1.89-5.84-4c-.48-.36-3.91-3.42-4.43-2.33-.31.66.83,2,1.19,2.46a9.48,9.48,0,0,0,2.31,2.07c2,1.27,4.5,1.54,6.8,2.15l.33.08.06,0h0C234,412.12,234.1,412.09,234.08,412Zm-6-1.73a9.61,9.61,0,0,1-2.63-1.78c-.51-.49-2.32-2.31-1.84-3.06.26-.4.47-.19,1,0a6.84,6.84,0,0,1,.65.37c.51.34,1,.73,1.46,1.11.84.67,1.68,1.32,2.55,1.95,1.42,1,2.88,2,4.37,2.93A48.32,48.32,0,0,1,228,410.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,405.85a18,18,0,0,1-5.23,9.13.09.09,0,0,1-.05,0,.15.15,0,0,1-.16-.06.13.13,0,0,1,0-.17l.15-.16c.51-4.14,1.06-8.27,1.49-12.43.1-1,.87-7.21,2.78-6.2,1.19.63,1.27,3.19,1.37,4.34A18.3,18.3,0,0,1,239.54,405.85Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,400.29c-.1-.35-.28-.7-.67-.46-.74.47-1,3.4-1.16,4.21-.51,3.34-1.3,6.56-2.11,9.83-.07.28-.14.56-.2.84l-.19.24a.13.13,0,0,0,.16.06s0-.06,0-.08.17-.22.25-.34h0a21.48,21.48,0,0,0,3-5.89,20.39,20.39,0,0,0,.89-4.1A11.78,11.78,0,0,0,238.43,400.29Zm-3.91,14.07a1.63,1.63,0,0,0-.11.17c0-.11.07-.22.1-.34a59.93,59.93,0,0,0,1.87-7.61c.22-1.31.36-2.62.63-3.92.11-.55.38-2.12.83-2.37s.45.36.5.71,0,.71,0,.95A21,21,0,0,1,234.52,414.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.82,423.92h-.61c0-.54,0-1.08,0-1.61-.07-2.16-.16-4.33-.29-6.5-.07-1.23-.16-2.46-.29-3.67,0-.05,0-.09,0-.13s0-.19,0-.3,0-.21,0-.32a26,26,0,0,0-2.1-8c-.39-.84-.81-1.67-1.25-2.48,0-.08-.09-.16-.13-.24l0-.06-.13-.24-.11-.18c-1.41-2.48-3-4.86-4.55-7.25l-1.31-2.05-.08-.13-.1-.15c-1.92-3-3.81-6.09-5.81-9.07-.08-.11.1-.21.18-.1,1.35,2,2.74,3.92,4.13,5.87l.55.78,1.09,1.55c.73,1,1.44,2.07,2.14,3.12a87.24,87.24,0,0,1,5.61,9.08c.12.24.24.48.35.72l.21.45c.08.17.16.35.23.52a28.11,28.11,0,0,1,2.06,9.61c0,.23,0,.46,0,.69s0,.22,0,.32a.91.91,0,0,0,0,.17c0,.08,0,.15,0,.23h0c0,.05,0,.11,0,.17s0,.39,0,.59q.13,3.25.19,6.5C234.77,422.53,234.79,423.23,234.82,423.92Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.61,384.67c-1.67-2.24-3.81-6.88-1.35-9.29a2.62,2.62,0,0,1,3.49-.25c1.3.94,1.89,2.71,2.31,4.19,1.13,3.92,1.87,7.93,3.28,11.78a3.06,3.06,0,0,1,.15.41c0,.08-.09.11-.12,0s-.1-.25-.14-.38C221.57,389.24,218.59,387.34,216.61,384.67Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.36,391.11a.25.25,0,0,0,0-.07,29,29,0,0,1-1.56-2.91,56.9,56.9,0,0,1-2.4-6.43c-.27-.84-1.47-5-2.94-3.32a3.67,3.67,0,0,0-.43,2.76,10.4,10.4,0,0,0,1.28,3.87,18.89,18.89,0,0,0,5.54,5.79l.3.22.06.11a.21.21,0,0,0,0,.06.08.08,0,0,0,0,0,.09.09,0,0,0,.12-.06A0,0,0,0,0,224.36,391.11Zm-.65-.46a22.1,22.1,0,0,1-4.7-4.71,11.81,11.81,0,0,1-1.53-3.13,9.68,9.68,0,0,1-.33-1.51,7.53,7.53,0,0,1-.07-1.16c0-.85.38-1.77.88-1.86s.83.25,1.24,1a7.29,7.29,0,0,1,.37.74c.27.64.48,1.3.69,2,.35,1.09.7,2.18,1.09,3.25.26.73.55,1.45.86,2.16a27.8,27.8,0,0,0,1.83,3.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.93,391c-.28,2.22-.71,4.43-1.16,6.62-.25,1.25-.52,2.49-.77,3.74a8.93,8.93,0,0,0-.31,4.16h0a.71.71,0,0,1,0,.2l0,0a.16.16,0,0,1-.28-.05l0-.09,0,0a5,5,0,0,1-.48-1.16,27.65,27.65,0,0,1-1.11-3.21,28.12,28.12,0,0,1-1.08-6.87,23.33,23.33,0,0,1,.65-6.18c.39-1.62,1-4,2.16-5.27s2,.67,2.32,1.58C82.53,386.47,82.19,388.84,81.93,391Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.93,386.23c-.81,0-1.4,2.62-1.69,3.75a22.82,22.82,0,0,0-.69,5.46,29.15,29.15,0,0,0,1.68,9.7c0,.12.08.25.13.38l0,0a.94.94,0,0,1,0,.09.17.17,0,0,0,.29.05,7.76,7.76,0,0,1-.13-.82c0-.25-.06-.49-.07-.73a38.58,38.58,0,0,1,.5-8C80.39,393,81,386.23,79.93,386.23Zm-.58,18.43c0,.36.1.72.16,1.07l-.24-.78a32.35,32.35,0,0,1-1.53-8.55,23,23,0,0,1,.36-4.9,20.2,20.2,0,0,1,.63-2.55c.11-.36.7-2.55,1.2-2.44.35.08.44,2.05.44,2.09,0,.4,0,.8,0,1.19,0,.82-.07,1.64-.14,2.45-.15,1.76-.4,3.52-.62,5.28A30.48,30.48,0,0,0,79.35,404.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71,397.1a21.23,21.23,0,0,1-6.59,7c-1.39,1-2.83,2-4.24,3a22.21,22.21,0,0,0-3.66,2.82,1,1,0,0,0-.14.15,6,6,0,0,0-.76,1.05.1.1,0,0,1-.07,0s0,.09,0,.13a0,0,0,0,1-.06,0,.77.77,0,0,0,0-.15h0a.11.11,0,0,1,0-.11l0-.05s0-.09,0-.14c.42-3.4,2.8-6.83,4.81-9.45a18.06,18.06,0,0,1,7.59-6.12c.78-.3,2.55-1.13,3.35-.49S95,396.48,94.71,397.1Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,397.11c-.71-.71-2.8,1-3.32,1.45a34.14,34.14,0,0,0-4.31,4.19,31.21,31.21,0,0,0-5.51,8h0a.36.36,0,0,1-.07.1.78.78,0,0,0,0,.14l0,.05a.11.11,0,0,0,0,.11l.11-.12c.25-.32.53-.63.81-.93a1,1,0,0,1,.14-.15,66.17,66.17,0,0,1,6.45-5.7A31.9,31.9,0,0,0,91,400.05C91.28,399.66,93,397.7,92.41,397.11Zm-.66,1.56c-1.75,2.91-4.8,5-7.39,7.17a34.86,34.86,0,0,0-4.9,4.66,33.19,33.19,0,0,1,5.09-7.17,44.08,44.08,0,0,1,3.5-3.6A18.54,18.54,0,0,1,90.18,398a7.28,7.28,0,0,1,1.43-.77C92.6,397,92.05,398.16,91.75,398.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,418a.18.18,0,0,1-.15.08l0,.06s0,.05,0,.07a.06.06,0,0,1-.08,0,29.43,29.43,0,0,1-6.78-9.92,15.2,15.2,0,0,1-1-4.89c0-1.14-.09-3.45.88-4.28,2-1.67,3.77,5.43,4,6.5.49,1.95.81,3.94,1.26,5.91.5,2.14,1.15,4.25,1.79,6.35A.16.16,0,0,1,78.85,418Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.85,418c-.11-.18-.21-.37-.31-.55A33.05,33.05,0,0,1,75,407.94a30.57,30.57,0,0,0-1.31-5c-.16-.39-.65-1.9-1.3-1.14-.34.4-.06,3.27.08,4a21.44,21.44,0,0,0,1.59,4.88,34.38,34.38,0,0,0,4.52,7.33l.15.2a0,0,0,0,0,0-.07l0-.06A.18.18,0,0,0,78.85,418Zm-4-6.11A23.68,23.68,0,0,1,73,407.19a16.75,16.75,0,0,1-.42-2,10.65,10.65,0,0,1-.13-1.59c0-1.29.11-1.63.33-1.68s.32.12.7.89A8,8,0,0,1,74,404.4c.2.77.37,1.54.54,2.31.34,1.55.65,3.1,1.1,4.62a25.7,25.7,0,0,0,2.74,6.21A39.2,39.2,0,0,1,74.85,411.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.68,411.23A9.68,9.68,0,0,1,85.87,415c-1.63,2.26-3.72,4.14-5.51,6.27-.26.32-.52.64-.77,1,0,0-.24.51-.23.47s0-.19.09-.5h0c.29-1.49,1.22-6,2.4-8.32a19.64,19.64,0,0,1,2.61-4.08c.5-.57,1.69-1.81,2.59-1.54S87.82,410.51,87.68,411.23Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,410.31c-1-.59-3.43,3.81-3.76,4.38a28.12,28.12,0,0,0-2.81,6.72c-.08.26-.15.52-.21.79s-.1.48-.1.49.21-.42.24-.47l.13-.17.64-.8c1.07-1.6,2.17-3.19,3.21-4.82a25.39,25.39,0,0,0,2-3.66C85.69,412.48,86.65,410.57,86.23,410.31ZM86,411.55c-1.36,3.83-4.13,6.85-6.25,10.26l-.11.16.09-.3a32.18,32.18,0,0,1,2.25-5.59,30.67,30.67,0,0,1,1.89-3.16A15.83,15.83,0,0,1,85,411.28c.2-.21.76-.79,1-.69S86,411.3,86,411.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.29,379.6c-2.85,6.53-10.31,9.57-13.54,15.87v0l-.29.58a.13.13,0,0,1-.21,0,.09.09,0,0,1,0-.11l.06-.14a34.22,34.22,0,0,1,4-11.43,17.27,17.27,0,0,1,7-7.41c.76-.4,2.25-1.22,3.11-.58S97.64,378.8,97.29,379.6Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.73,379.88c-.36-.27-.91.06-1.22.22a11,11,0,0,0-2.16,1.47,18.23,18.23,0,0,0-3.44,4.09,37.4,37.4,0,0,0-4,8.22c-.22.65-.41,1.32-.57,2,0,.08,0,.16-.05.25a.13.13,0,0,0,.21,0l.27-.57,0,0a21.09,21.09,0,0,1,2-3.73,51,51,0,0,1,4.25-5C90.61,386.05,96,380.8,94.73,379.88Zm-.46,1.51a24,24,0,0,1-3.37,4.09c-1.18,1.32-2.37,2.62-3.53,4a24.42,24.42,0,0,0-2.49,3.39A18.78,18.78,0,0,0,83.33,396a25.17,25.17,0,0,1,1.11-3.27.05.05,0,0,1,0,0,50.23,50.23,0,0,1,2.75-5.49.43.43,0,0,0,0-.07,22.66,22.66,0,0,1,3.14-4.39,13.57,13.57,0,0,1,2.24-1.9c.94-.6,1.76-1,2-.7S94.53,380.94,94.27,381.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.36,387.25c-.85,1.84-1.67,3.71-2.48,5.58-.38.88-.76,1.76-1.13,2.64l0,0c-.13.31-.27.63-.4,1A57.4,57.4,0,0,0,80,405.3a26.64,26.64,0,0,0-.68,4.91l0,.51h0V411a.92.92,0,0,0,0,.16c-.05,1.43,0,2.87,0,4.26,0,1.95.2,3.89.38,5.82a1.11,1.11,0,0,0,0,.17,2.28,2.28,0,0,0,0,.26c0,.05,0,.09,0,.14a1.94,1.94,0,0,0,0,.24c.06.62.12,1.24.17,1.87h-.6a39.29,39.29,0,0,1-.72-5.75v-.12a5.25,5.25,0,0,1,0-.56q0-.35,0-.69c0-.56,0-1.12-.05-1.66a40.86,40.86,0,0,1,.68-9.63l.06-.26,0-.11c0-.06,0-.12,0-.19l.08-.29.15-.52,0-.16a62.41,62.41,0,0,1,3.28-7.93c.22-.47.43-.93.66-1.4.12-.25.24-.51.37-.77l.58-1.17a.05.05,0,0,1,0,0c.91-1.83,1.85-3.65,2.75-5.49C87.26,387.1,87.4,387.17,87.36,387.25Z",
    style: {
      fill: "#009595"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.18,
    y: 71.24,
    width: 8.15,
    height: 352.89,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.28,
    cy: 130.83,
    r: 52.4,
    transform: "translate(64.3 343.35) rotate(-76.41)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.68,130.83A52.65,52.65,0,0,1,201.4,151.07a52.66,52.66,0,0,1,86-57.35,52.53,52.53,0,0,1,15.29,37.11Zm0,0a52.39,52.39,0,0,0-15.41-37,52,52,0,1,0,15.41,37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.28,174.61a43.79,43.79,0,1,1,43.78-43.78A43.83,43.83,0,0,1,250.28,174.61Zm0-78.68a34.9,34.9,0,1,0,34.89,34.9A34.94,34.94,0,0,0,250.28,95.93Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.83,
    y: 91.61,
    width: 8.89,
    height: 78.43,
    transform: "translate(-19.2 215.29) rotate(-45)",
    style: {
      fill: "#009595"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--401-error--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.47,200.9V169.74H110.18V159.23l62.14-80.52h8.05v80.17h15.41v10.86H180.37V200.9Zm-45.69-42H169.7V97.44Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.82,167.81v10.85H318.48V167.81h24.86V92.89a19.29,19.29,0,0,1-4.82,4.55A58.56,58.56,0,0,1,331,102a56.82,56.82,0,0,1-8.49,3.5,25.57,25.57,0,0,1-7.71,1.4V95.34a20.85,20.85,0,0,0,8.84-2.28,63,63,0,0,0,9.11-5.25,81.36,81.36,0,0,0,7.26-5.6q3-2.62,3.33-3.5h12.25v89.1Z",
    style: {
      fill: "#009595"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.06,68.54V70.6H216.92V55.82h10v2.06h-7.62v4.2h6.6V64h-6.6v4.52Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.47,70.6V55.82h6.44a4.07,4.07,0,0,1,1.84.41,4.9,4.9,0,0,1,1.45,1.09,5.32,5.32,0,0,1,.94,1.55,4.67,4.67,0,0,1,.35,1.75,4.92,4.92,0,0,1-.21,1.44,5.08,5.08,0,0,1-.59,1.27,3.82,3.82,0,0,1-.91,1,3.71,3.71,0,0,1-1.19.64l3.48,5.62h-2.65l-3.2-5.14H231.8V70.6Zm2.33-7.21h4.08a1.94,1.94,0,0,0,.91-.21,2.25,2.25,0,0,0,.7-.61,3.06,3.06,0,0,0,.46-.88,3.42,3.42,0,0,0,.16-1.07,2.74,2.74,0,0,0-.2-1.06,2.92,2.92,0,0,0-.52-.87,2.33,2.33,0,0,0-.74-.59,1.92,1.92,0,0,0-.89-.22h-4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.23,70.6V55.82h6.44a4.07,4.07,0,0,1,1.84.41A4.9,4.9,0,0,1,253,57.32a5.11,5.11,0,0,1,.94,1.55,4.67,4.67,0,0,1,.35,1.75,4.92,4.92,0,0,1-.21,1.44,5.06,5.06,0,0,1-.58,1.27,4,4,0,0,1-.92,1,3.61,3.61,0,0,1-1.19.64l3.48,5.62h-2.64L249,65.46h-3.41V70.6Zm2.34-7.21h4.08a1.93,1.93,0,0,0,.9-.21,2.15,2.15,0,0,0,.7-.61,3.06,3.06,0,0,0,.46-.88,3.43,3.43,0,0,0,.17-1.07,2.93,2.93,0,0,0-.2-1.06,3.4,3.4,0,0,0-.52-.87,2.48,2.48,0,0,0-.75-.59,1.89,1.89,0,0,0-.89-.22h-4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M263.14,70.7a6.55,6.55,0,0,1-2.89-.63A7.31,7.31,0,0,1,258,68.38a7.52,7.52,0,0,1-1.45-2.4,7.84,7.84,0,0,1-.51-2.77,7.54,7.54,0,0,1,.54-2.83,7.88,7.88,0,0,1,1.49-2.4,7.13,7.13,0,0,1,2.25-1.65,6.56,6.56,0,0,1,2.84-.62,6.23,6.23,0,0,1,2.88.66,7.25,7.25,0,0,1,2.23,1.71,7.84,7.84,0,0,1,1.44,2.41,7.68,7.68,0,0,1,.51,2.74,7.77,7.77,0,0,1-.53,2.83,7.49,7.49,0,0,1-1.49,2.38A7.28,7.28,0,0,1,266,70.09,6.53,6.53,0,0,1,263.14,70.7Zm-4.71-7.49a6.08,6.08,0,0,0,.34,2,5.41,5.41,0,0,0,.94,1.72,4.7,4.7,0,0,0,1.49,1.2,4.25,4.25,0,0,0,2,.45,4.15,4.15,0,0,0,2-.47,4.72,4.72,0,0,0,1.47-1.24,5.61,5.61,0,0,0,.91-1.73,6.35,6.35,0,0,0,0-4,5.28,5.28,0,0,0-.95-1.71,4.77,4.77,0,0,0-1.48-1.19,4.05,4.05,0,0,0-1.92-.44,4.19,4.19,0,0,0-2,.46,4.89,4.89,0,0,0-1.48,1.22,5.37,5.37,0,0,0-.92,1.72A6,6,0,0,0,258.43,63.21Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M272.65,70.6V55.82h6.44a4.07,4.07,0,0,1,1.84.41,4.9,4.9,0,0,1,1.45,1.09,5.32,5.32,0,0,1,.94,1.55,4.67,4.67,0,0,1,.35,1.75,4.92,4.92,0,0,1-.21,1.44,5.06,5.06,0,0,1-.58,1.27,4,4,0,0,1-.92,1,3.71,3.71,0,0,1-1.19.64l3.48,5.62h-2.64l-3.21-5.14H275V70.6ZM275,63.39h4.09a1.93,1.93,0,0,0,.9-.21,2.25,2.25,0,0,0,.7-.61,3.06,3.06,0,0,0,.46-.88,3.42,3.42,0,0,0,.16-1.07,2.93,2.93,0,0,0-.19-1.06,3.4,3.4,0,0,0-.52-.87,2.48,2.48,0,0,0-.75-.59,1.89,1.89,0,0,0-.89-.22h-4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9,198.83a2.62,2.62,0,0,0,2.39-1.24,4,4,0,0,0,.5-1.27,7.19,7.19,0,0,0,.15-1.47v-5.64h1.77v5.64a8.41,8.41,0,0,1-.27,2.16,5,5,0,0,1-.84,1.77,4.14,4.14,0,0,1-1.5,1.2,5.08,5.08,0,0,1-2.2.44,4.93,4.93,0,0,1-2.25-.47,4.06,4.06,0,0,1-1.48-1.23,5.1,5.1,0,0,1-.82-1.78,9,9,0,0,1-.25-2.09v-5.64h1.76v5.64a7.14,7.14,0,0,0,.15,1.48,3.67,3.67,0,0,0,.5,1.27,2.71,2.71,0,0,0,.94.9A2.91,2.91,0,0,0,193.9,198.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M202.8,192.5v7.84h-1.75V189.21h1.38l6.36,8v-8h1.77v11.11H209.1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M216.34,189.21h1.54l4.39,11.13h-1.85l-1.18-3H215l-1.16,3h-1.87Zm2.56,6.8-1.79-4.78L215.26,196Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M227.8,198.83a2.82,2.82,0,0,0,1.46-.34,2.76,2.76,0,0,0,.93-.9,3.75,3.75,0,0,0,.5-1.27,7.19,7.19,0,0,0,.15-1.47v-5.64h1.77v5.64a8.88,8.88,0,0,1-.26,2.16,5,5,0,0,1-.85,1.77A4.14,4.14,0,0,1,230,200a5.08,5.08,0,0,1-2.2.44,4.93,4.93,0,0,1-2.25-.47,4.06,4.06,0,0,1-1.48-1.23,4.91,4.91,0,0,1-.81-1.78,8.49,8.49,0,0,1-.26-2.09v-5.64h1.76v5.64a7.14,7.14,0,0,0,.15,1.48,3.88,3.88,0,0,0,.5,1.27,2.79,2.79,0,0,0,.94.9A2.93,2.93,0,0,0,227.8,198.83Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M243.11,190.76h-3.7v9.58h-1.77v-9.58h-3.71v-1.55h9.18Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253.74,189.21v11.13H252v-4.91h-5.61v4.91H244.6V189.21h1.76v4.65H252v-4.65Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M260.87,200.42a4.87,4.87,0,0,1-2.17-.48,5.41,5.41,0,0,1-1.68-1.27,5.65,5.65,0,0,1-1.09-1.81,5.82,5.82,0,0,1-.39-2.09,5.89,5.89,0,0,1,1.53-3.93,5.51,5.51,0,0,1,1.69-1.25,5.11,5.11,0,0,1,2.14-.46,4.84,4.84,0,0,1,2.17.49,5.53,5.53,0,0,1,1.68,1.3,5.81,5.81,0,0,1,1.08,1.81,5.66,5.66,0,0,1,.39,2.06,5.92,5.92,0,0,1-.4,2.13,5.75,5.75,0,0,1-1.12,1.8A5.53,5.53,0,0,1,263,200,4.87,4.87,0,0,1,260.87,200.42Zm-3.54-5.65a4.57,4.57,0,0,0,.25,1.52,4.14,4.14,0,0,0,.71,1.31,3.65,3.65,0,0,0,1.12.9,3.25,3.25,0,0,0,1.48.33,3,3,0,0,0,1.49-.35,3.45,3.45,0,0,0,1.11-.93,4.38,4.38,0,0,0,.69-1.3,4.92,4.92,0,0,0,.23-1.48,4.53,4.53,0,0,0-.25-1.52,3.85,3.85,0,0,0-.71-1.29,3.55,3.55,0,0,0-1.11-.89,3.07,3.07,0,0,0-1.45-.34,3.2,3.2,0,0,0-1.51.35,3.55,3.55,0,0,0-1.11.92,4.24,4.24,0,0,0-.7,1.29A4.73,4.73,0,0,0,257.33,194.77Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M268,200.34V189.21h4.85a3,3,0,0,1,1.38.31,3.47,3.47,0,0,1,1.09.83,3.84,3.84,0,0,1,.72,1.16,3.56,3.56,0,0,1,.25,1.32,3.69,3.69,0,0,1-.59,2,3.32,3.32,0,0,1-.69.76,3.07,3.07,0,0,1-.89.48l2.61,4.23h-2l-2.41-3.87h-2.57v3.87Zm1.76-5.43h3.07a1.39,1.39,0,0,0,.68-.16,1.63,1.63,0,0,0,.53-.45,2.49,2.49,0,0,0,.34-.67,2.36,2.36,0,0,0,.13-.8,2.15,2.15,0,0,0-.15-.8,2.4,2.4,0,0,0-.39-.66,1.86,1.86,0,0,0-.57-.44,1.41,1.41,0,0,0-.66-.17h-3Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.39,200.34V189.21h1.76v11.13Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.89,199l6.75-8.23H282v-1.55h8.66v1.35l-6.6,8.23h6.61v1.55h-8.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M300.15,198.79v1.55h-7.64V189.21H300v1.55h-5.74v3.17h5v1.46h-5v3.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M302,200.34V189.21h4a5.9,5.9,0,0,1,2.35.44,4.87,4.87,0,0,1,1.7,1.19,5.06,5.06,0,0,1,1,1.76,6.7,6.7,0,0,1,.35,2.16,6.4,6.4,0,0,1-.39,2.29,5.06,5.06,0,0,1-1.08,1.76,5,5,0,0,1-1.71,1.13,6.16,6.16,0,0,1-2.24.4Zm7.59-5.58a5.2,5.2,0,0,0-.24-1.62,3.41,3.41,0,0,0-.72-1.26,3.27,3.27,0,0,0-1.14-.82,3.73,3.73,0,0,0-1.53-.3h-2.2v8h2.2a3.79,3.79,0,0,0,1.55-.31,3.17,3.17,0,0,0,1.15-.85,3.65,3.65,0,0,0,.7-1.27A5.47,5.47,0,0,0,309.55,194.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--police-tape--inject-75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.49,
    y: 211.56,
    width: 12.87,
    height: 171.16,
    transform: "translate(-164.24 397.64) rotate(-79.74)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.97 277.39 71.03 285.67 72.86 275.56 82.97 277.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.13 280.86 87.18 291.23 76.94 289.38 91.89 279.01 102.13 280.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.29 284.33 106.33 294.7 96.09 292.85 111.06 282.48 121.29 284.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.45 287.8 125.5 298.17 115.26 296.31 130.21 285.94 140.45 287.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.61 291.27 144.65 301.64 134.42 299.78 149.37 289.41 159.61 291.27",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.77 294.74 163.81 305.11 153.58 303.25 168.53 292.88 178.77 294.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.93 298.2 182.97 308.57 172.74 306.72 187.69 296.35 197.93 298.2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.09 301.67 202.13 312.04 191.9 310.19 206.86 299.82 217.09 301.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.25 305.14 221.29 315.51 211.06 313.66 226.01 303.29 236.25 305.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.59 309.94 239 318.72 230.21 317.13 240.59 309.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.35,
    y: 290.71,
    width: 171.16,
    height: 12.87,
    transform: "translate(-32.29 19.33) rotate(-6.43)",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3,305.93a.71.71,0,0,1,0,.32.66.66,0,0,1-.16.28,1,1,0,0,1-.25.21.63.63,0,0,1-.3.1.47.47,0,0,1-.4-.12.57.57,0,0,1-.2-.39.69.69,0,0,1,0-.32.85.85,0,0,1,.16-.28,1,1,0,0,1,.24-.21.88.88,0,0,1,.3-.1.48.48,0,0,1,.41.12A.57.57,0,0,1,74.3,305.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,303.31l1.6-.18a1.81,1.81,0,0,1,.78.05,1.41,1.41,0,0,1,.58.31,1.59,1.59,0,0,1,.37.51,2.14,2.14,0,0,1,.19.68,3.14,3.14,0,0,1-.08,1.11,2.55,2.55,0,0,1-.47.93,2.67,2.67,0,0,1-.78.67,2.76,2.76,0,0,1-1,.32l-1.61.18Zm1.24,3.47a1.18,1.18,0,0,0,.56-.2,1.34,1.34,0,0,0,.4-.42,1.54,1.54,0,0,0,.23-.56,1.77,1.77,0,0,0,0-.65,1.1,1.1,0,0,0-.29-.69.74.74,0,0,0-.66-.2l-.57.06L79,306.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12,307.23a1.63,1.63,0,0,1-.74-.08,1.44,1.44,0,0,1-.58-.35,2,2,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2.21,2.21,0,0,1,0-.68,3,3,0,0,1,.22-.66,2.65,2.65,0,0,1,.36-.6,2.58,2.58,0,0,1,.5-.49,2.28,2.28,0,0,1,.6-.36,2,2,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.07,1.54,1.54,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.36,2.36,0,0,1,.19.69,2.33,2.33,0,0,1-.11,1,2.82,2.82,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.44,2.44,0,0,1,84.12,307.23Zm.1-1a1,1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,2,2,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.59,1.59,0,0,0-.1-.39,1,1,0,0,0-.18-.3.72.72,0,0,0-.29-.2.93.93,0,0,0-.38,0,1.2,1.2,0,0,0-.56.22,1.33,1.33,0,0,0-.4.45,1.82,1.82,0,0,0-.22.56,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.09.39,1,1,0,0,0,.19.31.72.72,0,0,0,.29.2A.68.68,0,0,0,84.22,306.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.77,302.13l.81-.09,1.64,2.48.25-2.69,1-.12-.45,4.58-.82.1L89.61,304l-.25,2.62-1,.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,306A1.63,1.63,0,0,1,94,306a1.56,1.56,0,0,1-.58-.35,1.92,1.92,0,0,1-.39-.57,2.2,2.2,0,0,1-.19-.69,2.23,2.23,0,0,1,0-.68,3.79,3.79,0,0,1,.21-.65,3.13,3.13,0,0,1,.37-.6,2.84,2.84,0,0,1,.49-.49,2.51,2.51,0,0,1,.61-.36,2,2,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.07,1.54,1.54,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.36,2.36,0,0,1,.19.69,2.33,2.33,0,0,1-.11,1,3,3,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.44,2.44,0,0,1,94.78,306Zm.1-.95a1.1,1.1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,2.32,2.32,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.59,1.59,0,0,0-.1-.39,1.05,1.05,0,0,0-.18-.31.81.81,0,0,0-.29-.19.78.78,0,0,0-.38,0,1.2,1.2,0,0,0-.56.22,1.4,1.4,0,0,0-.4.44,1.9,1.9,0,0,0-.25,1.16,1.59,1.59,0,0,0,.09.39,1,1,0,0,0,.19.31.66.66,0,0,0,.29.2A.67.67,0,0,0,94.88,305.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.43,302l-1.28.15.09-.93,3.58-.41-.08.93-1.28.15-.36,3.65-1,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.09,305a1.54,1.54,0,0,1-.72-.08,1.85,1.85,0,0,1-.58-.37,2.11,2.11,0,0,1-.39-.58,2.36,2.36,0,0,1-.19-.69,2.3,2.3,0,0,1,0-.64,2.94,2.94,0,0,1,.19-.64,3.27,3.27,0,0,1,.35-.59,3.24,3.24,0,0,1,.48-.5,2.92,2.92,0,0,1,.61-.37,2.19,2.19,0,0,1,.72-.19,1.61,1.61,0,0,1,1,.16,1.22,1.22,0,0,1,.59.64l-.85.66a.74.74,0,0,0-.14-.28.7.7,0,0,0-.47-.24h-.27a1.1,1.1,0,0,0-.56.22,1.33,1.33,0,0,0-.4.45,1.8,1.8,0,0,0-.21.56,1.85,1.85,0,0,0,0,.57,1.24,1.24,0,0,0,.1.4,1.13,1.13,0,0,0,.19.32.84.84,0,0,0,.29.2.74.74,0,0,0,.37,0l.27-.06a1.74,1.74,0,0,0,.27-.14,1.27,1.27,0,0,0,.25-.22,1.08,1.08,0,0,0,.19-.31l.8.41a1.58,1.58,0,0,1-.33.48,2.5,2.5,0,0,1-.47.39,3.11,3.11,0,0,1-.55.27A2.91,2.91,0,0,1,104.09,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.41,304.68l.45-4.59,1.92-.21a1,1,0,0,1,.49.05,1.36,1.36,0,0,1,.38.24,1.7,1.7,0,0,1,.26.38,1.51,1.51,0,0,1,.13.46,1.85,1.85,0,0,1,0,.47,2.51,2.51,0,0,1-.16.46,2.57,2.57,0,0,1-.26.41,1.89,1.89,0,0,1-.37.32l.77,1.6-1.17.13-.66-1.38-.58.06-.14,1.48Zm2.13-2.62a.36.36,0,0,0,.18-.08.65.65,0,0,0,.15-.18.74.74,0,0,0,.1-.26,1,1,0,0,0,0-.3.55.55,0,0,0-.12-.33.28.28,0,0,0-.23-.1l-.83.1-.12,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,304.05a1.63,1.63,0,0,1-.74-.08,1.7,1.7,0,0,1-.58-.35,1.92,1.92,0,0,1-.39-.57,2.2,2.2,0,0,1-.19-.69,2.23,2.23,0,0,1,0-.68,3.79,3.79,0,0,1,.21-.65,3.13,3.13,0,0,1,.37-.6,2.9,2.9,0,0,1,.49-.5,2.84,2.84,0,0,1,.61-.35,2.23,2.23,0,0,1,.67-.19,1.63,1.63,0,0,1,.74.08,1.54,1.54,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.31,2.31,0,0,1,.08,1.7,3,3,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.44,2.44,0,0,1,112.36,304.05Zm.1-.95a1.1,1.1,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,2.32,2.32,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.59,1.59,0,0,0-.1-.39,1.05,1.05,0,0,0-.18-.31.81.81,0,0,0-.29-.19.78.78,0,0,0-.38,0,1.1,1.1,0,0,0-.56.22,1.4,1.4,0,0,0-.4.44,1.9,1.9,0,0,0-.25,1.16,1.59,1.59,0,0,0,.09.39,1.08,1.08,0,0,0,.19.31.75.75,0,0,0,.29.2A.77.77,0,0,0,112.46,303.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.64,303.58a3,3,0,0,1-.94-.05,2.36,2.36,0,0,1-.83-.32l.54-1a.55.55,0,0,0,.14.1,1.4,1.4,0,0,0,.3.15,2.13,2.13,0,0,0,.42.11,1.55,1.55,0,0,0,.48,0,.69.69,0,0,0,.42-.16.39.39,0,0,0,.09-.3.26.26,0,0,0-.09-.17.52.52,0,0,0-.21-.11,1.66,1.66,0,0,0-.29-.09l-.36-.07a1.94,1.94,0,0,1-.72-.31.79.79,0,0,1-.29-.57,1.63,1.63,0,0,1,.08-.74,1.69,1.69,0,0,1,.37-.59,1.82,1.82,0,0,1,.58-.4,2.09,2.09,0,0,1,.7-.2,2.17,2.17,0,0,1,.44,0l.4.07.36.12.3.15-.54.93a.39.39,0,0,0-.11-.09l-.25-.12a3,3,0,0,0-.35-.09,1.59,1.59,0,0,0-.38,0,.7.7,0,0,0-.4.17.41.41,0,0,0-.11.34.3.3,0,0,0,.23.25,3.29,3.29,0,0,0,.58.14l.45.12a1.59,1.59,0,0,1,.37.18.92.92,0,0,1,.25.27,1.11,1.11,0,0,1,.12.4,1.51,1.51,0,0,1-.08.78,1.45,1.45,0,0,1-.39.55,1.81,1.81,0,0,1-.6.36A3.22,3.22,0,0,1,116.64,303.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.38,303.15a2.7,2.7,0,0,1-.94,0,2.36,2.36,0,0,1-.83-.32l.54-1a.55.55,0,0,0,.14.1,1.4,1.4,0,0,0,.3.15,3.16,3.16,0,0,0,.42.11,1.52,1.52,0,0,0,.48,0,.75.75,0,0,0,.42-.16.39.39,0,0,0,.09-.3.26.26,0,0,0-.09-.17.68.68,0,0,0-.21-.12l-.29-.08-.36-.07a1.87,1.87,0,0,1-.72-.31.79.79,0,0,1-.29-.57,1.5,1.5,0,0,1,.08-.74,1.56,1.56,0,0,1,.37-.59,1.82,1.82,0,0,1,.58-.4,2.09,2.09,0,0,1,.7-.2,2.16,2.16,0,0,1,.44,0l.4.07a3,3,0,0,1,.36.12l.3.15-.54.93a.39.39,0,0,0-.11-.09l-.25-.12a3,3,0,0,0-.35-.09,1.2,1.2,0,0,0-.38,0,.67.67,0,0,0-.4.17.41.41,0,0,0-.11.34.3.3,0,0,0,.23.25,4.52,4.52,0,0,0,.58.14l.45.12a1.82,1.82,0,0,1,.37.18.81.81,0,0,1,.25.27,1.11,1.11,0,0,1,.12.4,1.62,1.62,0,0,1-.08.78,1.45,1.45,0,0,1-.39.55,1.81,1.81,0,0,1-.6.36A2.69,2.69,0,0,1,120.38,303.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.65,300.14a.85.85,0,0,1,0,.32,1,1,0,0,1-.16.28.82.82,0,0,1-.25.21.71.71,0,0,1-.3.1.49.49,0,0,1-.41-.12.56.56,0,0,1-.19-.39.7.7,0,0,1,0-.32,1,1,0,0,1,.16-.28,1,1,0,0,1,.25-.21,1,1,0,0,1,.3-.1.53.53,0,0,1,.41.12A.61.61,0,0,1,125.65,300.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,297.52l1.61-.18a2.13,2.13,0,0,1,.77.05,1.54,1.54,0,0,1,.58.31,1.56,1.56,0,0,1,.38.52,2.36,2.36,0,0,1,.18.67,3.19,3.19,0,0,1-.08,1.12,2.55,2.55,0,0,1-.47.93,2.5,2.5,0,0,1-.78.66,2.71,2.71,0,0,1-1,.33l-1.6.18Zm1.24,3.48a1.3,1.3,0,0,0,.56-.2,1.37,1.37,0,0,0,.41-.42,2,2,0,0,0,.25-1.22,1.15,1.15,0,0,0-.29-.69.77.77,0,0,0-.66-.2l-.57.07-.26,2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.5,301.44a1.78,1.78,0,0,1-.74-.07,1.58,1.58,0,0,1-.58-.36,2,2,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,1.94,1.94,0,0,1,0-.68,2.54,2.54,0,0,1,.21-.66,2.65,2.65,0,0,1,.36-.6,2.58,2.58,0,0,1,.5-.49,2.28,2.28,0,0,1,.6-.36,2,2,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.07,1.54,1.54,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.36,2.36,0,0,1,.19.69,2.33,2.33,0,0,1-.11,1,2.82,2.82,0,0,1-.49.92,2.76,2.76,0,0,1-.78.7A2.44,2.44,0,0,1,135.5,301.44Zm.1-.95a1,1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,2,2,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.59,1.59,0,0,0-.1-.39,1,1,0,0,0-.18-.3.72.72,0,0,0-.29-.2.93.93,0,0,0-.38,0,1.2,1.2,0,0,0-.56.22,1.33,1.33,0,0,0-.4.45,2.11,2.11,0,0,0-.22.56,2,2,0,0,0,0,.59,2.23,2.23,0,0,0,.09.39,1,1,0,0,0,.19.31.72.72,0,0,0,.29.2A.68.68,0,0,0,135.6,300.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.14,296.34l.81-.09,1.64,2.48.25-2.69,1-.12-.45,4.59-.82.09L141,298.19l-.25,2.62-1,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.16,300.24a1.83,1.83,0,0,1-.75-.07,1.54,1.54,0,0,1-.57-.36,1.85,1.85,0,0,1-.4-.56,2.34,2.34,0,0,1-.18-.69,2.21,2.21,0,0,1,0-.68,2.54,2.54,0,0,1,.21-.66,3.13,3.13,0,0,1,.37-.6,2.84,2.84,0,0,1,.49-.49,2.65,2.65,0,0,1,.6-.36,2,2,0,0,1,.68-.18,1.59,1.59,0,0,1,.73.07,1.5,1.5,0,0,1,.58.36,1.87,1.87,0,0,1,.39.56,2.36,2.36,0,0,1,.19.69,2.5,2.5,0,0,1-.11,1,3,3,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.44,2.44,0,0,1,146.16,300.24Zm.09-.95a1,1,0,0,0,.57-.22,1.58,1.58,0,0,0,.4-.45,1.77,1.77,0,0,0,.21-.57,1.48,1.48,0,0,0,0-.59,1.24,1.24,0,0,0-.09-.39,1,1,0,0,0-.19-.3.69.69,0,0,0-.28-.2.93.93,0,0,0-.38,0,1.2,1.2,0,0,0-.57.22,1.58,1.58,0,0,0-.4.45,1.8,1.8,0,0,0-.21.56,1.71,1.71,0,0,0,0,.59,1.24,1.24,0,0,0,.09.39,1,1,0,0,0,.19.31.69.69,0,0,0,.28.2A.68.68,0,0,0,146.25,299.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82,296.17l-1.28.15.09-.93,3.59-.41-.09.93-1.27.15-.36,3.65-1,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47,299.19a1.59,1.59,0,0,1-.73-.08,1.93,1.93,0,0,1-.57-.37,2.11,2.11,0,0,1-.39-.58,2.36,2.36,0,0,1-.19-.69,2.3,2.3,0,0,1,0-.64,2.94,2.94,0,0,1,.19-.64,2.78,2.78,0,0,1,.35-.59,3.24,3.24,0,0,1,.48-.5,2.92,2.92,0,0,1,.61-.37,2.13,2.13,0,0,1,.72-.19,1.61,1.61,0,0,1,1,.16,1.27,1.27,0,0,1,.59.64l-.85.66a.74.74,0,0,0-.14-.28.87.87,0,0,0-.22-.17.72.72,0,0,0-.25-.07h-.27a1.24,1.24,0,0,0-.57.22,1.41,1.41,0,0,0-.39.45,1.8,1.8,0,0,0-.21.56,1.59,1.59,0,0,0,0,.57,1.24,1.24,0,0,0,.09.4,1.16,1.16,0,0,0,.2.32.84.84,0,0,0,.29.2.74.74,0,0,0,.37,0l.27-.06a1.74,1.74,0,0,0,.27-.14,1.27,1.27,0,0,0,.25-.22,1.08,1.08,0,0,0,.19-.31l.8.41a1.76,1.76,0,0,1-.33.49,3,3,0,0,1-.48.38,2.73,2.73,0,0,1-.54.27A2.91,2.91,0,0,1,155.47,299.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,298.89l.45-4.58,1.92-.22a1.12,1.12,0,0,1,.49.05,1.05,1.05,0,0,1,.37.25,1.31,1.31,0,0,1,.27.38,1.39,1.39,0,0,1,.1.92,1.9,1.9,0,0,1-.15.46,2.07,2.07,0,0,1-.27.41,1.63,1.63,0,0,1-.36.33l.76,1.6-1.16.13-.66-1.39-.58.06-.14,1.48Zm2.13-2.62a.29.29,0,0,0,.18-.08.45.45,0,0,0,.15-.18.67.67,0,0,0,.1-.26,1,1,0,0,0,0-.3.58.58,0,0,0-.12-.32.26.26,0,0,0-.23-.1l-.83.09-.12,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,298.25a1.63,1.63,0,0,1-.74-.07,1.66,1.66,0,0,1-.58-.36,1.76,1.76,0,0,1-.39-.56,2.2,2.2,0,0,1-.19-.69,2.55,2.55,0,0,1,.24-1.33,3.29,3.29,0,0,1,.36-.6,2.88,2.88,0,0,1,1.1-.86,2.52,2.52,0,0,1,.68-.18,1.6,1.6,0,0,1,.73.08,1.66,1.66,0,0,1,.58.36,1.73,1.73,0,0,1,.38.56,2.09,2.09,0,0,1,.19.69,2.34,2.34,0,0,1-.1,1,3.26,3.26,0,0,1-.49.92,3,3,0,0,1-.78.69A2.34,2.34,0,0,1,163.76,298.25Zm.1-.94a1.1,1.1,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,1.9,1.9,0,0,0,.25-1.16,1.59,1.59,0,0,0-.09-.39,1.08,1.08,0,0,0-.19-.31.77.77,0,0,0-.28-.19.83.83,0,0,0-.39,0,1.1,1.1,0,0,0-.56.22,1.53,1.53,0,0,0-.4.44,2.18,2.18,0,0,0-.22.57,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39.89.89,0,0,0,.19.31.72.72,0,0,0,.28.2A.78.78,0,0,0,163.86,297.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,297.79a3.3,3.3,0,0,1-.94,0,2.45,2.45,0,0,1-.83-.33l.54-1a.49.49,0,0,0,.14.11,2.12,2.12,0,0,0,.72.25,1.55,1.55,0,0,0,.48,0,.69.69,0,0,0,.42-.16.39.39,0,0,0,.09-.3.26.26,0,0,0-.09-.17.52.52,0,0,0-.21-.11l-.29-.09-.36-.07a2,2,0,0,1-.72-.31.79.79,0,0,1-.29-.57,1.63,1.63,0,0,1,.08-.74,1.79,1.79,0,0,1,.37-.59,2.21,2.21,0,0,1,1.28-.6,1.62,1.62,0,0,1,.44,0,2.4,2.4,0,0,1,.4.06l.36.12.3.15-.54.93a.28.28,0,0,0-.11-.09l-.25-.11a1.79,1.79,0,0,0-.35-.1,1.15,1.15,0,0,0-.37,0,.64.64,0,0,0-.4.16.41.41,0,0,0-.12.34.3.3,0,0,0,.23.25,4.27,4.27,0,0,0,.58.15l.46.11a1.51,1.51,0,0,1,.36.18,1.06,1.06,0,0,1,.25.27.82.82,0,0,1,.12.4,1.51,1.51,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.85,1.85,0,0,1-.59.35A3.48,3.48,0,0,1,168,297.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,297.36a3,3,0,0,1-.95,0A2.44,2.44,0,0,1,170,297l.55-1a.42.42,0,0,0,.13.1,1.8,1.8,0,0,0,.31.15,3.44,3.44,0,0,0,.41.11,1.93,1.93,0,0,0,.48,0,.69.69,0,0,0,.42-.16.38.38,0,0,0,.1-.3.28.28,0,0,0-.09-.18,1,1,0,0,0-.21-.11l-.3-.08-.36-.08a1.86,1.86,0,0,1-.72-.3.83.83,0,0,1-.29-.57,1.56,1.56,0,0,1,.09-.75,1.48,1.48,0,0,1,.37-.58,2,2,0,0,1,.57-.41,2.21,2.21,0,0,1,.7-.19,2.17,2.17,0,0,1,.44,0l.41.07a2.06,2.06,0,0,1,.35.12l.3.15-.53.92-.12-.08a1.47,1.47,0,0,0-.25-.12,1.69,1.69,0,0,0-.34-.09,1.22,1.22,0,0,0-.38,0,.65.65,0,0,0-.4.17.38.38,0,0,0-.11.34.3.3,0,0,0,.22.25,4.52,4.52,0,0,0,.58.14,2.8,2.8,0,0,1,.46.12,1.51,1.51,0,0,1,.36.18.84.84,0,0,1,.26.27,1.11,1.11,0,0,1,.12.4,1.59,1.59,0,0,1-.09.77,1.41,1.41,0,0,1-.39.56,2.08,2.08,0,0,1-.59.36A2.8,2.8,0,0,1,171.78,297.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,294.35a.69.69,0,0,1,0,.32.78.78,0,0,1-.16.28.72.72,0,0,1-.25.21.71.71,0,0,1-.3.1.49.49,0,0,1-.41-.12.61.61,0,0,1-.19-.39.69.69,0,0,1,0-.32.78.78,0,0,1,.16-.28,1.21,1.21,0,0,1,.24-.21.76.76,0,0,1,.3-.1.49.49,0,0,1,.41.12A.62.62,0,0,1,177.05,294.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.07,291.73l1.6-.18a2.19,2.19,0,0,1,.78.05,1.49,1.49,0,0,1,.57.31,1.43,1.43,0,0,1,.38.52,2.27,2.27,0,0,1,.18.67,2.78,2.78,0,0,1-.08,1.12,2.61,2.61,0,0,1-.46.93,2.5,2.5,0,0,1-.78.66,2.76,2.76,0,0,1-1,.33l-1.6.18Zm1.24,3.48a1.3,1.3,0,0,0,.56-.2,1.46,1.46,0,0,0,.4-.42,1.8,1.8,0,0,0,.23-.57,2.35,2.35,0,0,0,0-.65,1.21,1.21,0,0,0-.29-.69.78.78,0,0,0-.66-.2l-.57.07-.27,2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.86,295.65a1.66,1.66,0,0,1-.75-.07,1.54,1.54,0,0,1-.57-.36,1.63,1.63,0,0,1-.4-.56A2.72,2.72,0,0,1,185,294a2.59,2.59,0,0,1,0-.68,2.67,2.67,0,0,1,.21-.66,3.58,3.58,0,0,1,.36-.59,3,3,0,0,1,.5-.5,3.67,3.67,0,0,1,.6-.36,2.62,2.62,0,0,1,.68-.18,1.59,1.59,0,0,1,.73.08,1.61,1.61,0,0,1,.58.35,1.92,1.92,0,0,1,.39.57,2.36,2.36,0,0,1,.19.69,2.45,2.45,0,0,1-.11,1,2.81,2.81,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.3,2.3,0,0,1,186.86,295.65Zm.09-.94a1.2,1.2,0,0,0,.57-.22,1.9,1.9,0,0,0,.4-.45,2,2,0,0,0,.21-.57,1.76,1.76,0,0,0,0-.6,1.24,1.24,0,0,0-.09-.38,1.08,1.08,0,0,0-.19-.31.67.67,0,0,0-.28-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.57.22,1.68,1.68,0,0,0-.4.44,1.77,1.77,0,0,0-.21.57,1.7,1.7,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39,1.08,1.08,0,0,0,.19.31.8.8,0,0,0,.28.2A.78.78,0,0,0,187,294.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.51,290.55l.81-.09,1.64,2.48.26-2.69,1-.12-.44,4.59-.82.09-1.64-2.41L192.1,295l-1,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.54,294.45a1.63,1.63,0,0,1-.74-.08,1.56,1.56,0,0,1-.58-.35,2,2,0,0,1-.39-.56,2.36,2.36,0,0,1-.19-.69,2,2,0,0,1,0-.69,2.6,2.6,0,0,1,.21-.65,3.08,3.08,0,0,1,.36-.6,2.9,2.9,0,0,1,.5-.49,2.28,2.28,0,0,1,.6-.36,2,2,0,0,1,.67-.18,1.63,1.63,0,0,1,.74.07,1.54,1.54,0,0,1,.57.36,1.87,1.87,0,0,1,.39.56,2.36,2.36,0,0,1,.19.69,2.49,2.49,0,0,1-.1,1,3.26,3.26,0,0,1-.49.92,3,3,0,0,1-.79.7A2.44,2.44,0,0,1,197.54,294.45Zm.1-.95a1.1,1.1,0,0,0,.57-.22,1.41,1.41,0,0,0,.39-.45,1.9,1.9,0,0,0,.25-1.16,2.23,2.23,0,0,0-.09-.39,1,1,0,0,0-.19-.3.66.66,0,0,0-.29-.2.91.91,0,0,0-.38,0,1.2,1.2,0,0,0-.56.22,1.33,1.33,0,0,0-.4.45,2.11,2.11,0,0,0-.22.56,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39.94.94,0,0,0,.18.31.72.72,0,0,0,.29.2A.68.68,0,0,0,197.64,293.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.19,290.38l-1.28.15.09-.93,3.59-.41-.09.93-1.27.15-.36,3.65-1,.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.86,293.4a1.59,1.59,0,0,1-.73-.08,1.7,1.7,0,0,1-.57-.37,2.11,2.11,0,0,1-.39-.58,2.08,2.08,0,0,1-.19-.7,1.92,1.92,0,0,1,0-.63,2.47,2.47,0,0,1,.19-.64,2.91,2.91,0,0,1,.34-.59,3.31,3.31,0,0,1,.49-.5,2.68,2.68,0,0,1,.61-.37,2.4,2.4,0,0,1,.72-.2,1.75,1.75,0,0,1,1,.16,1.33,1.33,0,0,1,.59.65l-.85.66a.92.92,0,0,0-.15-.28.68.68,0,0,0-.21-.17.77.77,0,0,0-.26-.07h-.26a1.1,1.1,0,0,0-.57.22,1.41,1.41,0,0,0-.39.45,2.11,2.11,0,0,0-.22.56,1.85,1.85,0,0,0,0,.57,1.56,1.56,0,0,0,.1.4,1.16,1.16,0,0,0,.2.32.8.8,0,0,0,.28.2.77.77,0,0,0,.37,0,1.31,1.31,0,0,0,.27-.06,1.47,1.47,0,0,0,.28-.14,1.64,1.64,0,0,0,.25-.22,1.35,1.35,0,0,0,.19-.31l.8.41a1.61,1.61,0,0,1-.34.48,2.5,2.5,0,0,1-.47.39,2.73,2.73,0,0,1-.54.27A3.1,3.1,0,0,1,206.86,293.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.17,293.1l.45-4.59,1.92-.21a1.06,1.06,0,0,1,.48.05,1.09,1.09,0,0,1,.38.25,1.26,1.26,0,0,1,.27.37,1.49,1.49,0,0,1,.12.46,1.47,1.47,0,0,1,0,.47,1.9,1.9,0,0,1-.15.46,2.07,2.07,0,0,1-.27.41,1.59,1.59,0,0,1-.36.32l.76,1.6-1.16.14-.66-1.39-.58.06-.14,1.48Zm2.13-2.62a.29.29,0,0,0,.18-.08.65.65,0,0,0,.15-.18,1,1,0,0,0,.1-.26,1,1,0,0,0,0-.3.56.56,0,0,0-.13-.32.24.24,0,0,0-.22-.11l-.83.1-.12,1.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.12,292.47a1.65,1.65,0,0,1-1.32-.43,1.92,1.92,0,0,1-.39-.57,2.2,2.2,0,0,1-.19-.69,2.55,2.55,0,0,1,.24-1.33,3.67,3.67,0,0,1,.36-.6,2.9,2.9,0,0,1,.5-.49,2.28,2.28,0,0,1,.6-.36,2,2,0,0,1,.68-.18,1.6,1.6,0,0,1,.73.07,1.66,1.66,0,0,1,.58.36,1.85,1.85,0,0,1,.38.56,2.09,2.09,0,0,1,.19.69,2.33,2.33,0,0,1-.1,1,3.26,3.26,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.48,2.48,0,0,1,215.12,292.47Zm.1-1a1.1,1.1,0,0,0,.57-.22,1.67,1.67,0,0,0,.39-.45,1.9,1.9,0,0,0,.25-1.16,1.59,1.59,0,0,0-.09-.39,1.08,1.08,0,0,0-.19-.31.77.77,0,0,0-.28-.19.83.83,0,0,0-.39,0,1.1,1.1,0,0,0-.56.22,1.53,1.53,0,0,0-.4.44,2.32,2.32,0,0,0-.22.57,2,2,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39.81.81,0,0,0,.19.31.72.72,0,0,0,.28.2A.78.78,0,0,0,215.22,291.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,292a3.37,3.37,0,0,1-1,0,2.32,2.32,0,0,1-.82-.33l.54-1a.39.39,0,0,0,.13.11,2.33,2.33,0,0,0,.31.14,2.13,2.13,0,0,0,.42.11,1.52,1.52,0,0,0,.48,0,.63.63,0,0,0,.41-.16.36.36,0,0,0,.1-.3.26.26,0,0,0-.09-.17.52.52,0,0,0-.21-.11l-.3-.08-.35-.08a1.87,1.87,0,0,1-.72-.31.8.8,0,0,1-.3-.57,1.5,1.5,0,0,1,.09-.74,1.64,1.64,0,0,1,.37-.59,1.87,1.87,0,0,1,.58-.4,2.1,2.1,0,0,1,.69-.2,1.69,1.69,0,0,1,.45,0,2.57,2.57,0,0,1,.4.06l.35.12.3.15-.53.93a.39.39,0,0,0-.11-.09l-.26-.11a1.52,1.52,0,0,0-.34-.1,1.21,1.21,0,0,0-.38,0,.67.67,0,0,0-.4.16.38.38,0,0,0-.11.34.28.28,0,0,0,.23.25,4.07,4.07,0,0,0,.57.15,4.46,4.46,0,0,1,.46.11,1.82,1.82,0,0,1,.37.18,1.27,1.27,0,0,1,.25.27,1.11,1.11,0,0,1,.12.4,1.62,1.62,0,0,1-.09.78,1.49,1.49,0,0,1-.39.56,1.74,1.74,0,0,1-.59.35A2.71,2.71,0,0,1,219.4,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.13,291.58a3.3,3.3,0,0,1-.94,0,2.45,2.45,0,0,1-.83-.33l.54-1a.49.49,0,0,0,.14.11,2.15,2.15,0,0,0,.3.14,2.58,2.58,0,0,0,.42.11,1.55,1.55,0,0,0,.48,0,.69.69,0,0,0,.42-.16.35.35,0,0,0,.09-.3.26.26,0,0,0-.09-.17.55.55,0,0,0-.2-.11l-.3-.09-.36-.07a2,2,0,0,1-.72-.31.83.83,0,0,1-.29-.57,1.63,1.63,0,0,1,.08-.74,1.79,1.79,0,0,1,.37-.59,2.21,2.21,0,0,1,1.28-.6,1.62,1.62,0,0,1,.44,0,2.4,2.4,0,0,1,.4.06l.36.12.3.15-.53.93a.35.35,0,0,0-.12-.09l-.25-.11a1.69,1.69,0,0,0-.34-.1,1.22,1.22,0,0,0-.38,0,.64.64,0,0,0-.4.16.38.38,0,0,0-.11.34.29.29,0,0,0,.22.25,3.29,3.29,0,0,0,.58.14l.46.12a1.51,1.51,0,0,1,.36.18.91.91,0,0,1,.25.27.82.82,0,0,1,.12.4,1.51,1.51,0,0,1-.08.78,1.49,1.49,0,0,1-.39.56,1.85,1.85,0,0,1-.59.35A3.48,3.48,0,0,1,223.13,291.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,288.56a.69.69,0,0,1,0,.32.85.85,0,0,1-.16.28.72.72,0,0,1-.25.21.91.91,0,0,1-.3.11.54.54,0,0,1-.41-.13.61.61,0,0,1-.19-.39.7.7,0,0,1,0-.32,1.56,1.56,0,0,1,.16-.28,1,1,0,0,1,.25-.2.63.63,0,0,1,.3-.1.53.53,0,0,1,.41.11A.56.56,0,0,1,228.41,288.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,285.94l1.6-.18a2.11,2.11,0,0,1,.77.05,1.54,1.54,0,0,1,.58.31,1.43,1.43,0,0,1,.38.52,2.36,2.36,0,0,1,.18.67,3,3,0,0,1-.08,1.12,2.51,2.51,0,0,1-1.25,1.59,2.71,2.71,0,0,1-1,.33l-1.6.18Zm1.24,3.48a1.34,1.34,0,0,0,.56-.2,1.46,1.46,0,0,0,.4-.42,1.8,1.8,0,0,0,.23-.57,2.35,2.35,0,0,0,0-.65,1.16,1.16,0,0,0-.3-.69.76.76,0,0,0-.65-.2l-.57.07-.27,2.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.24,289.86a1.63,1.63,0,0,1-.74-.07,1.54,1.54,0,0,1-.57-.36,1.74,1.74,0,0,1-.4-.56,2.36,2.36,0,0,1-.19-.69,2.59,2.59,0,0,1,0-.68,2.67,2.67,0,0,1,.21-.66,3.21,3.21,0,0,1,.36-.59,3,3,0,0,1,.5-.5,3.67,3.67,0,0,1,.6-.36,2.62,2.62,0,0,1,.68-.18,1.6,1.6,0,0,1,.73.08,1.7,1.7,0,0,1,.58.35,1.92,1.92,0,0,1,.39.57,2.36,2.36,0,0,1,.18.68,2.31,2.31,0,0,1-.1,1,2.81,2.81,0,0,1-.49.92,3.06,3.06,0,0,1-.78.7A2.29,2.29,0,0,1,238.24,289.86Zm.1-.94a1.11,1.11,0,0,0,.57-.23,1.41,1.41,0,0,0,.39-.45,1.58,1.58,0,0,0,.22-.57,2,2,0,0,0,0-.59,1.18,1.18,0,0,0-.09-.38,1.08,1.08,0,0,0-.19-.31.67.67,0,0,0-.28-.19.68.68,0,0,0-.38,0,1,1,0,0,0-.57.22,1.53,1.53,0,0,0-.4.44,1.77,1.77,0,0,0-.21.57,1.7,1.7,0,0,0,0,.59,1.59,1.59,0,0,0,.1.39,1.08,1.08,0,0,0,.19.31.7.7,0,0,0,.28.19A.78.78,0,0,0,238.34,288.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 272.91,
    width: 6.23,
    height: 146.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.92 424.09 45.31 424.09 67.49 419.37 73.73 419.37 95.92 424.09",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.98,
    y: 272.91,
    width: 6.23,
    height: 146.46,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.4 424.09 214.79 424.09 236.98 419.37 243.22 419.37 265.4 424.09",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "45.17 424.08 96.37 423.84 147.58 423.75 250 423.58 352.42 423.75 403.63 423.84 454.83 424.08 403.63 424.32 352.42 424.41 250 424.58 147.58 424.41 96.37 424.32 45.17 424.08",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-75"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 362.31,
    cy: 245.03,
    r: 105.23,
    transform: "translate(-67.15 327.96) rotate(-45)",
    style: {
      fill: "#009595",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-75"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.39,208.21c10.83,24.64,25,48.88,31.14,43.07,5.47-5.14,1.32-28.49,1.07-28.91-.85-1.42-8.9-11.09-22.26-24.57C382,185.34,379.55,197.19,384.39,208.21Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.39,208.21c10.83,24.64,25,48.88,31.14,43.07,5.47-5.14,1.32-28.49,1.07-28.91-.85-1.42-8.9-11.09-22.26-24.57C382,185.34,379.55,197.19,384.39,208.21Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,245c-.38,2.77-1.14,5.06-2.45,6.29-6.18,5.81-20.32-18.43-31.15-43.07-2.17-4.94-2.87-10-1.89-13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.24,196.19c.62-.43,1.23-.88,1.81-1.33a32.07,32.07,0,0,1,3.29,2.94l.52.53c-.86.7-1.77,1.4-2.72,2.06a24.45,24.45,0,0,1-9.33,3.3,21.26,21.26,0,0,1-.74-5.05A19.07,19.07,0,0,0,389.24,196.19ZM384.3,208a1.54,1.54,0,0,0,.08.19c.66,1.5,1.34,3,2,4.5,3.85-1.26,7.89-3,10.6-5.17,1.28-1.05,2.5-2.15,3.64-3.26l-3.53-3.67c-1.05,1-2.16,2-3.33,3C391.56,205.37,387.92,206.87,384.3,208Zm4.63,10.09c.74,1.55,1.49,3.09,2.25,4.58A54.69,54.69,0,0,0,404,214.05c1-1,2-2,2.93-3-1.07-1.18-2.23-2.44-3.47-3.76a42.46,42.46,0,0,1-3,3.06A49.64,49.64,0,0,1,388.93,218.1Zm4.32,8.61c.8,1.54,1.61,3,2.42,4.49a86.75,86.75,0,0,0,15.1-10.78c.83-.77,1.61-1.58,2.37-2.39-.95-1.11-2.07-2.41-3.39-3.88-.77.88-1.6,1.74-2.46,2.55A82.52,82.52,0,0,1,393.25,226.71Zm5.12,9.19q1.38,2.29,2.72,4.33a91.67,91.67,0,0,0,16.3-13.32,41.4,41.4,0,0,0-.79-4.53,13.49,13.49,0,0,0-.89-1.21c-.59.67-1.2,1.34-1.81,2A84.58,84.58,0,0,1,398.37,235.9Zm5.87,8.83a41.29,41.29,0,0,0,3.32,3.9c3.43-2.93,7.18-6.26,10.77-9.71,0-2.3-.14-4.64-.34-6.81C413.61,236.55,408.66,241,404.24,244.73Zm8.44,7.34a3,3,0,0,0,2.85-.78,8.43,8.43,0,0,0,2.07-4.19C416,248.82,414.29,250.49,412.68,252.07Z",
    style: {
      fill: "#030402",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,251.35c8.77-2,15.63-23.91,20.16-44.4.78-3.53-24.5-5.22-25.29-1.44C404.79,227.09,403.78,253.79,414.43,251.35Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.91,210s11.58,2.35,25.17,6c0,0-2.65,25.07-16.33,35.2-4.3,3.18-10.16-1.11-10.91-12.33C405.06,227.26,407.91,210,407.91,210Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.4,241.31c3.43,1,7.19,3.53,10.44,6.1a25.09,25.09,0,0,1-3.75,3.54,28.45,28.45,0,0,0-8.18-4.77c-.58-.17-1.17-.35-1.76-.5a24.62,24.62,0,0,1-1.2-5.52C407.41,240.48,408.91,240.86,410.4,241.31ZM405.73,236a44.34,44.34,0,0,1,5,.83,50.85,50.85,0,0,1,13.69,5.73c.88-1.45,1.69-3,2.42-4.49a56.12,56.12,0,0,0-15-6.21,49.84,49.84,0,0,0-6.1-1C405.72,232.59,405.69,234.31,405.73,236Zm.27-9.28a45.48,45.48,0,0,1,6.26,1,83.59,83.59,0,0,1,16.4,6.17c.63-1.65,1.18-3.29,1.65-4.86a87,87,0,0,0-16.92-6.29,52.37,52.37,0,0,0-7-1.06C406.27,223.23,406.12,225,406,226.69Zm.85-9c2.24.17,4.69.43,7.08.81a83.78,83.78,0,0,1,17.77,5.18c.47-2,.8-3.78,1-5.1a87.74,87.74,0,0,0-18-5.11c-2.47-.39-5-.66-7.24-.84C407.32,214,407.08,215.72,406.85,217.73Z",
    style: {
      fill: "#030402",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.53,240.08c-.17-2.27-.23-4.56-.26-6.85-.06-4.69.18-9.38.55-14.06.21-2.68.55-5.34.89-8,0,0-.06-.06-.07,0a79,79,0,0,0-2,14.2,88.9,88.9,0,0,0,0,11.19s-.05,0-.05,0a17.93,17.93,0,0,0-.28,5.66c0,.08.14.08.13,0a28.2,28.2,0,0,1,.23-5.35c.07.92.15,1.84.27,2.75a24.26,24.26,0,0,0,1.78,7.17c0,.07.14,0,.12,0A24.36,24.36,0,0,1,406.53,240.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.74,181.91c8.48.92,23.4,8.78,28.43,11.8,6.74,4,19.66,27.44,20.41,28.95.17.34-.57,8.75-5.58,11.42-2.18,1.16-7,1-9.05,2.4s-.78,7.56-2.69,8.31c-3.78,1.46-10.23-4-12.17-4.83-9.24-3.92-.71-25.05-4-29.54-4.49-6.17-9.33-18.22-16.85-18.8s-25.88,22.14-27.91,29.75-5.48,30.79-5.86,39.8-18.86,33.32-32.26,35.38c-38,5.83-49.22-26.76-49.69-43.33s14.91-34.62,31.39-47.53C334.25,181.16,369.14,179.78,388.74,181.91Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M388.74,181.91c8.48.92,23.4,8.78,28.43,11.8,6.74,4,19.66,27.44,20.41,28.95.17.34-.57,8.75-5.58,11.42-2.18,1.16-7,1-9.05,2.4s-.78,7.56-2.69,8.31c-3.78,1.46-10.23-4-12.17-4.83-9.24-3.92-.71-25.05-4-29.54-4.49-6.17-9.33-18.22-16.85-18.8s-25.88,22.14-27.91,29.75-5.48,30.79-5.86,39.8-18.86,33.32-32.26,35.38c-38,5.83-49.22-26.76-49.69-43.33s14.91-34.62,31.39-47.53C334.25,181.16,369.14,179.78,388.74,181.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M432,234.07c-2.17,1.17-7,1-9,2.41s-.79,7.56-2.69,8.3c-3.79,1.47-10.24-4-12.18-4.82a6.58,6.58,0,0,1-3.62-4.06,0,0,0,0,0,0,0h0a4.6,4.6,0,0,1,3.69-5.52c1.83-.18,4,.14,4.31-.47s-4.32-5-1.33-8,6.68-3.08,8.23-2c2.39,1.75,1.44,6.25,4.49,6.9a4.93,4.93,0,0,0,6-4.83c.07-3,4.73-4,7.12-.46a6.44,6.44,0,0,1,.58,1.08l0,.08C437.75,223,437,231.41,432,234.07Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.85,226.78c-3.05-.65-2.1-5.15-4.49-6.9-2.53-5-7.66-14.39-6.67-15.08s13.49,12.16,17.17,16.89a2.28,2.28,0,0,0,0,.26A4.92,4.92,0,0,1,423.85,226.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.46,229.87c-.23.5-1.75.38-3.29.41-.26-1.23-.6-2.93-.75-3.65a51.36,51.36,0,0,1-.34-9.68c.32-2.69.88-3.91,1.32-.69.19,1.4.66,3.84,1.18,6.27C408.8,225.48,412.73,229.3,412.46,229.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,209.51c4.68,3,14.45,5.71,17.46,6.74,4,1.38,17,1.73,18.13.6.64-.62-12.7-2.34-15.17-3-2.3-.67-11-6.42-14.18-9.32l-1.58,1.21Q300.58,207.53,298.27,209.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.74,262.12c-3.25.56-24.58,13.56-29.61,14.23s-18.45,3-14.18,4.54,14.25,5.76,21.55,4.32,16.27-15.72,18.79-17.95S344.32,261.5,340.74,262.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,261.61c-5.36-.2-17.29,9-14.41,9.84s12.3-4.57,15.92-6.26S330.72,261.89,323,261.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.79,216.67c-.55-4.81-11.54-4.79-12.59-10.84-.81-4.65,4.38-4.54,8.4-1.07,0,0,3.88,5.39,4.28,6.62S404.79,216.67,404.79,216.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.67,204.44a3.25,3.25,0,0,0-3.58-1.49s1.27-2.87-.48-4.81c-.9-1-3.28-.43-3.28-.43a3.85,3.85,0,0,0-.75-4c-1.32-1.3-3.51-.54-3.51-.54s-.16-2.66-1.94-3.54c-3.59-1.8-15.83,8.33-14,14.41.86,2.83,3.72.19,3.72.19s-3.19,4.78-1.17,7.36,5.53-1.07,5.53-1.07-3.05,4.66-.68,7.12,5.34-1.69,5.34-1.69-1.19,4.1,1.05,5.57c3.71,2.42,5.47-5.94,8.69-7.53l5.15,3.2S436.21,206.83,434.67,204.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.71,193.28s0-.1,0-.07a27.59,27.59,0,0,0-12,11.19c-.08.15.14.36.26.2A56.91,56.91,0,0,1,422.71,193.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.37,197.64c.05,0,0-.12-.07-.09a25.83,25.83,0,0,0-12.32,13c-.08.2,0,.46.16.23C417,207,423.15,200.57,427.37,197.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.85,216.47c2.42-5.52,6.36-9.71,11-13.43.06,0,0-.13-.08-.1-2.78,1.19-5.51,3.87-7.45,6.14a15.87,15.87,0,0,0-3.7,7.3C419.63,216.49,419.79,216.59,419.85,216.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.56,442.84c-.82.07-15.48,2.08-16.84,1.07-13.77-10.32-34.35-38.77-34.85-40.25-.33-.93,12.19-13.22,12.26-13.31.33-.44,2.3-2.61,5-5.56l10-24.42L433.73,382,420.4,408.63l-3.3,4.65-.4.47a94.56,94.56,0,0,0,5.17,16c.46,1.05,5.61,5.28,6,6.15C429.19,438.73,428.71,442.74,427.56,442.84Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.57,442.84c-.84.07-15.49,2.08-16.85,1.06-13.77-10.31-34.35-38.76-34.85-40.24-.33-.93,12.19-13.22,12.26-13.3.31-.41,2-2.31,4.43-4.94L420.7,409.5l-3.6,3.78-.41.47a96.39,96.39,0,0,0,5.17,16c.47,1.05,5.62,5.29,6,6.15C429.19,438.73,428.71,442.74,427.57,442.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.16,443c-.45.37-16.63,1.92-17.79,1.05-11-8.33-35.05-38.84-35.43-40.67-.21-.95,6.45-8.13,14-14.35l28,24.74s2.52,10.45,5.07,16c.58,1.24,5.61,5.09,6.11,6C429.65,438.5,428.8,442.49,428.16,443Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.19,434.65a9.81,9.81,0,0,0-7.51-.7,8.35,8.35,0,0,0-5,4.13c0,.06.09.11.13.06,2.51-3.58,8-5.13,12.29-3.36A.07.07,0,0,0,426.19,434.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.69,399.45c-3-3.07-7.77,1.59-4.77,4.66S391.7,402.52,388.69,399.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.4,413.37c-.11-2.52-2.92-3.27-4.95-3a20.21,20.21,0,0,0-7.79,2.77,11.51,11.51,0,0,0-1,.62c-.14.1-.27.2-.4.28h0l-.1.09-.32.24a.1.1,0,0,0,0,.16.48.48,0,0,0,0,.54.42.42,0,0,0,.24.18c.89.2,1.8.44,2.71.68.15.05.31.08.47.12a20.86,20.86,0,0,0,6.77.89C426,416.75,428.5,415.74,428.4,413.37Zm-9.17,2c-.77-.15-1.54-.33-2.3-.5s-1.3-.28-2-.4l-.27-.05-.25,0,.22-.1h0l1.45-.62a36.08,36.08,0,0,1,4-1.5,21.54,21.54,0,0,1,2.85-.7c1.49-.23,6.38.4,3.55,3.48C425,416.6,421.12,415.75,419.23,415.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,414.8a.11.11,0,0,0,.13-.1,1.42,1.42,0,0,0,0-.3.2.2,0,0,0,0-.13s0,0,0,0a2.33,2.33,0,0,0,0-.53,13.75,13.75,0,0,0-.21-1.92,19.82,19.82,0,0,0-2.51-7.12c-1.06-1.75-3.38-3.49-5.42-2a1.2,1.2,0,0,0-.21.17c-1.68,1.4-.95,3.87.08,5.45a19.71,19.71,0,0,0,4.17,4.24c1.09.85,2.21,1.68,3.27,2.53h0A.46.46,0,0,0,414.59,414.8Zm-4-3.69c-1.48-1.26-4.51-3.75-4.14-6a3,3,0,0,1,.57-1.48c1.23-1.54,3.75,1.05,4.36,2.15a24.81,24.81,0,0,1,1.91,4.77c.35,1.15.64,2.31,1,3.47v0l.07.22a1.15,1.15,0,0,0-.17-.14c-.14-.13-.27-.26-.42-.38C412.73,412.83,411.66,412,410.62,411.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.8,418c-2.53-2.87-6.51-5.24-10.42-4.9-.16,0-.13.23,0,.28a52.74,52.74,0,0,1,10.14,5A.24.24,0,0,0,418.8,418Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.94,421c-2.53-2.87-6.52-5.24-10.43-4.9-.15,0-.13.23,0,.28a52.66,52.66,0,0,1,10.13,5A.24.24,0,0,0,419.94,421Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.07,423.91c-2.53-2.87-6.51-5.24-10.43-4.9-.15,0-.13.23,0,.28a52.74,52.74,0,0,1,10.14,5A.24.24,0,0,0,421.07,423.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.21,426.87c-2.54-2.87-6.52-5.24-10.43-4.9-.15,0-.13.23,0,.28a52.66,52.66,0,0,1,10.13,5A.25.25,0,0,0,422.21,426.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.1,440.79c-4.5-.2-9,.29-13.54.25L413,441a2.33,2.33,0,0,1-1.6-.33,23.78,23.78,0,0,1-2.22-2.38q-2.24-2.43-4.46-4.88c-5.95-6.55-11.8-13.2-17.6-19.88-1.64-1.89-3.29-3.76-4.93-5.65s-3.42-3.67-5.07-5.55c-.06-.07-.17,0-.11.08,1.41,1.79,2.7,3.66,4.14,5.42s2.88,3.52,4.36,5.26q4.38,5.16,8.86,10.24t9,10.09c1.53,1.69,3.07,3.36,4.62,5l2.25,2.43a2.73,2.73,0,0,0,2.16,1c5.21,0,10.46-.54,15.66-.74C428.3,441.17,428.32,440.8,428.1,440.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.13,407.84l-33.52-21.75s22.5-69.22,20.84-72c-2.17-3.61-36-18.93-48.08-32-15.84-17.25-7.19-38.37-7.19-38.37l31.67,0s4.22,11.41,5.08,12.79c3.45,5.56,56.11,24.48,61.35,47C459.66,326.61,424.13,407.84,424.13,407.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.37,282.06c6.2,6.74,18.16,14.06,28.61,20.08l-17.7-58.43-18.1,0S347.53,264.82,363.37,282.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.83,456.18c-.83-.05-15.62-.3-16.8-1.52-12-12.29-28-43.55-28.31-45.09-.18-1,14.07-11.21,14.14-11.28,1.5-1.45,29.52-23.51,29.52-23.51L309.25,405,281,425.36l-.48.42a94.51,94.51,0,0,0,2.68,16.55c.29,1.11,4.74,6.08,5,7C289.06,452.37,288,456.25,286.83,456.18Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.84,456.18c-.84-.06-15.63-.3-16.82-1.52-12-12.29-28-43.55-28.3-45.09-.19-1,14.07-11.2,14.14-11.28.37-.35,2.35-2,5.14-4.19l24.14,28.09L281,425.37l-.47.4a96.39,96.39,0,0,0,2.67,16.57c.31,1.1,4.74,6.07,5,7C289.06,452.36,288,456.25,286.84,456.18Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,456.44c-.49.29-16.72-.64-17.73-1.68-9.63-9.92-28.72-43.73-28.82-45.59-.06-1,7.62-7.06,16-12.06l23.91,28.72s.89,10.72,2.58,16.54c.38,1.32,4.76,5.89,5.12,6.86C289.55,452.21,288.11,456,287.39,456.44Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.72,447.88a9.78,9.78,0,0,0-7.31-1.84,8.33,8.33,0,0,0-5.54,3.32c0,.05.07.13.11.08A10.66,10.66,0,0,1,286.64,448C286.73,448,286.8,447.93,286.72,447.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,407.37c-2.49-3.49-7.92.38-5.42,3.88S257.54,410.86,255,407.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.16,427.18c.27-2.51-2.4-3.68-4.43-3.75a20.07,20.07,0,0,0-8.12,1.54,10.28,10.28,0,0,0-1.06.47l-.44.21s0,0,0,0l-.11.07-.35.19a.1.1,0,0,0,0,.16.5.5,0,0,0-.1.53.38.38,0,0,0,.21.22c.85.34,1.71.71,2.58,1.08.14.08.29.13.44.2a20.65,20.65,0,0,0,6.56,1.9C289.28,430.16,291.9,429.54,292.16,427.18Zm-9.37.56c-.74-.27-1.47-.56-2.2-.84s-1.24-.48-1.87-.7a1.34,1.34,0,0,0-.26-.09l-.24-.08.23-.07h0c.52-.13,1-.25,1.52-.39a38.54,38.54,0,0,1,4.14-.88,22,22,0,0,1,2.92-.26c1.51,0,6.25,1.37,3,4C288.25,429.85,284.6,428.42,282.79,427.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.29,426.49a.1.1,0,0,0,.14-.08,1.69,1.69,0,0,0,0-.3.23.23,0,0,0,0-.12s0,0,0,0a2.49,2.49,0,0,0,.07-.52,13.86,13.86,0,0,0,.09-1.93,20.07,20.07,0,0,0-1.4-7.42c-.78-1.89-2.8-4-5.05-2.84l-.23.14c-1.87,1.13-1.53,3.68-.74,5.4a19.17,19.17,0,0,0,3.47,4.82c.94,1,1.93,2,2.84,3l0,0A.46.46,0,0,0,278.29,426.49Zm-3.36-4.26c-1.28-1.46-3.89-4.39-3.17-6.58a3,3,0,0,1,.78-1.37c1.45-1.33,3.55,1.6,4,2.79a22.65,22.65,0,0,1,.79,2.82c.16.72.27,1.45.37,2.18.17,1.2.28,2.39.42,3.58v0c0,.08,0,.15,0,.23a1,1,0,0,0-.14-.17l-.35-.44C276.75,424.26,275.82,423.26,274.93,422.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,430.28c-2.07-3.21-5.64-6.17-9.56-6.42-.16,0-.17.2-.06.26a52.55,52.55,0,0,1,9.26,6.48A.24.24,0,0,0,282,430.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,433.38c-2.07-3.22-5.64-6.17-9.56-6.43-.16,0-.17.21-.06.27a52.55,52.55,0,0,1,9.26,6.48A.24.24,0,0,0,282.64,433.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.31,436.48c-2.07-3.22-5.64-6.17-9.56-6.43-.16,0-.17.21-.06.27A52.55,52.55,0,0,1,283,436.8.24.24,0,0,0,283.31,436.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,439.58c-2.06-3.22-5.63-6.17-9.56-6.43-.15,0-.16.21-.05.27a53,53,0,0,1,9.26,6.47A.24.24,0,0,0,284,439.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.67,454.23c-4.41-.88-9-1.09-13.41-1.82l-1.56-.25a2.37,2.37,0,0,1-1.54-.58,24.82,24.82,0,0,1-1.83-2.68c-1.22-1.84-2.44-3.67-3.65-5.51q-7.33-11.07-14.37-22.33c-1.33-2.11-2.68-4.22-4-6.33s-2.82-4.15-4.16-6.26c0-.08-.17,0-.13.06,1.12,2,2.11,4,3.27,6s2.31,3.92,3.5,5.86q3.54,5.78,7.2,11.47t7.4,11.36q1.89,2.85,3.81,5.67c.61.92,1.23,1.83,1.85,2.74a2.75,2.75,0,0,0,2,1.34c5.14.83,10.42,1.05,15.59,1.65C287.82,454.64,287.89,454.28,287.67,454.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85,243.72s1.54,23.16-.29,33.21l-3.47,1.17s-14.75,64.12-20,78.61c-8.21,22.44-78.21,67.61-78.21,67.61L257,392.44s67.92-45.56,68.11-47.09c1.12-8.67,14.8-63.28,14.26-64.76-6.1-16.88,5.63-36.87,5.63-36.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,276.93c-.84.08-1.68,0-2.52.16s-1.67.24-2.5.38c-1.62.27-3.21.69-4.8,1.12a48.34,48.34,0,0,0-9.26,3.43c-.11.06,0,.2.09.18,3.19-.8,6.34-1.79,9.53-2.6,1.55-.39,3.11-.72,4.65-1.1.82-.21,1.64-.42,2.46-.6s1.6-.48,2.42-.66C391.68,277.2,391.62,276.92,391.44,276.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34,251c0-.07-.1-.06-.1,0-.37,6.34-.52,10.9-1.71,17.16a7.26,7.26,0,0,1-1.47,3.6c-.48.53-1.12,1-1.81.54a2.27,2.27,0,0,1-.85-1.9,42.88,42.88,0,0,1,.36-4.8c.1-1.5.17-3,.22-4.51.14-3.64,0-6,0-9.64,0-.13-.2-.11-.2,0,0,3.77-.51,6.28-.82,10-.15,1.81-.34,3.62-.51,5.43-.15,1.56-.63,3.43-.05,4.95a2.84,2.84,0,0,0,2.25,1.86c0,.1-.07.19-.1.29-.17.46-.33.91-.49,1.37-.32.91-.6,1.83-1,2.72,0,.12.1.24.19.13a8,8,0,0,0,1.42-2.57,12.49,12.49,0,0,0,.49-2c1.27-.21,2.2-1.51,2.68-2.6a14.66,14.66,0,0,0,1-4.2c.24-1.84.42-3.7.56-5.56A55.92,55.92,0,0,0,390.34,251Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,264.15c.12.19,56.14-6.44,56.81-7,.95-.78,5.61-45.14-2.4-60.36-2-3.81-11-8.45-18-2.41C350.74,214.4,337.15,263.48,337.57,264.15Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,264.15c.12.19,56.14-6.44,56.81-7,.95-.78,5.61-45.14-2.4-60.36-2-3.81-11-8.45-18-2.41C350.74,214.4,337.15,263.48,337.57,264.15Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374,194.39a11.82,11.82,0,0,1,3-1.93c2.59,2.11,5.62,4.12,8.11,4.65a41.57,41.57,0,0,0,7.4.82,30.66,30.66,0,0,1,1.73,5.12h-.35a48.37,48.37,0,0,1-9.85-1c-4-.85-8.22-3.89-11.34-6.55C373.13,195.14,373.56,194.75,374,194.39Zm-8.24,8.7c4.25,2.8,11,6.7,16.42,7.43a63.15,63.15,0,0,0,8,.49c2.1,0,4-.08,5.46-.2-.21-1.75-.48-3.45-.79-5.05a65.37,65.37,0,0,1-12-.3c-4-.54-9.66-3.63-13.76-6.28Q367.37,201,365.75,203.09Zm-7,10c5.26,2.6,14.44,6.49,23.47,7,.94.06,1.89.08,2.82.08a67.85,67.85,0,0,0,11.31-1.05c-.09-1.73-.21-3.45-.36-5.12a59.62,59.62,0,0,1-13.46,1c-7.81-.48-16-3.86-21-6.27C360.62,210.16,359.68,211.6,358.78,213.07Zm-5.25,9.27c5.78,2.12,18.56,6.43,28.72,7,.94.06,1.89.08,2.83.08a67.45,67.45,0,0,0,11.51-1.09c0-1.71,0-3.44-.06-5.18a59.71,59.71,0,0,1-14,1.1c-9-.55-20.75-4.4-26.58-6.5C355.14,219.3,354.32,220.82,353.53,222.34Zm-4.75,9.86c5.21,1.9,19.21,6.45,33.34,6.45h.3a109.18,109.18,0,0,0,13.94-1.1c.09-1.67.14-3.4.18-5.17a106.24,106.24,0,0,1-14.14,1.18c-12.93.08-26.23-4.14-31.47-6Q349.81,229.89,348.78,232.2Zm-5,12.06c4.28.71,22.64,3.54,38.05,3.54h.56a109.35,109.35,0,0,0,13.36-1c.14-1.61.27-3.35.38-5.21a105.16,105.16,0,0,1-13.76,1.14h-.53c-13.79,0-30.55-2.42-36.17-3.3Q344.69,241.92,343.81,244.26ZM339.74,256h0a271.84,271.84,0,0,0,29.44,1.76c4.47,0,9.06-.16,13.45-.54l12-1.08c.21-1,.46-2.85.72-5.19l-13.21,1.19c-15.9,1.4-35.12-.47-40.81-1.09Z",
    style: {
      fill: "#030402",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.31,204.55c-2.68-.06-7.91-5.44-9.8-9.8a68.63,68.63,0,0,1,1.28-6.91c.42-2.21.83-4.68,1-7l14,4.8a36.51,36.51,0,0,0-2.19,8.64,4.2,4.2,0,0,0,0,.94.85.85,0,0,1,0,.16C392.77,197.23,392.52,204.65,388.31,204.55Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.31,184.89c1,3.3,4,8.42,12.32,9.42a36.36,36.36,0,0,1,2.19-8.63l-14-4.8C380.71,182.19,380.52,183.54,380.31,184.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.23,166c-.8,5.27,4,19.45,8.06,22.17,5.88,3.95,14.46,3.16,17.55-3.68,3-6.63-3.59-25-8-27.36C386.28,153.67,376.41,158.24,375.23,166Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.55,172.76s-.05.08,0,.11c.39,1,.68,2.14-.08,2.79,0,0,0,.07,0,.06C390.48,175.16,390.08,173.61,389.55,172.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,172.06c-1.61.47-.57,3.66.93,3.23S389.66,171.68,388.3,172.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.24,170.81s.1,0,.11.06c.28,1,.78,2.1,1.78,2.14,0,0,.05.06,0,.06C396,173.27,395.35,171.8,395.24,170.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,169.49c1.55-.63,2.7,2.53,1.26,3.11S394.49,170,395.8,169.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,170.3c-.35.31-.73.55-1.1.82a2.27,2.27,0,0,1-1.29.64.71.71,0,0,1-.65-.58,1.74,1.74,0,0,1,.83-1.58,2.63,2.63,0,0,1,1.76-.62A.76.76,0,0,1,389,170.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.21,166.35a12.79,12.79,0,0,1-1.38.09,2.23,2.23,0,0,1-1.42-.18.72.72,0,0,1-.24-.84,1.76,1.76,0,0,1,1.57-.86,2.58,2.58,0,0,1,1.81.45A.76.76,0,0,1,396.21,166.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,180.68a9,9,0,0,1,3.82-1.51c.1,0,.13-.31.12-.42h0s-.76-2.07-.76-2.07c.32.05,1.93.21,1.78-.18a52.67,52.67,0,0,0-4.66-9.62.1.1,0,0,0-.17.09c1.11,3.11,2.76,6,3.93,9.1a6.14,6.14,0,0,0-1.73.05c-.09.07.92,2.15,1,2.5a5.09,5.09,0,0,0-3.47,1.65C391.49,180.67,391.47,181.12,392,180.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.31,183.73c.31.15.65.39,1,.3a2.75,2.75,0,0,0,1-.61,0,0,0,0,1,.06,0,1.39,1.39,0,0,1-1.06.95,1.09,1.09,0,0,1-1.06-.6C390.19,183.76,390.26,183.71,390.31,183.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.92,178.88c-.93.29-3.8,1.87-2.89,3.19.4.57,1.4.08,2-.9A6.56,6.56,0,0,0,393.92,178.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.73,181.61c-.62.68-1.36.94-1.7.46a1,1,0,0,1,0-1.1C391.58,180.8,392.81,180.56,392.73,181.61Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.86,175.49l.56,2.15s3.87-.56,4.43-.52,5.73,1.21,8.08.49,4.49-1.9,4.79-2.58.79-1.61,1.31-1.61c.76,0,1,.77,1.72.77a4.23,4.23,0,0,0,3.06-1.41,5.79,5.79,0,0,0,.84-1.85,29.29,29.29,0,0,0-1.34-4.23,9.09,9.09,0,0,0-4.09.26c-.74.24-1.68,1.67-2.27,1.82-1.77.46-4.28-.06-6.29.66a11.35,11.35,0,0,0-3.43,2.07,33.44,33.44,0,0,1-3.22,2.85C379.39,174.58,375.86,175.49,375.86,175.49Zm19.22-4.25A3.13,3.13,0,0,1,396.7,168c1-.54,2.51.46,2.69,1.58a3,3,0,0,1-1.46,3.28C396.47,173.64,395.34,172.38,395.08,171.24Zm-10.49,3.24c-.19-1.16,1.16-2.9,2.77-3.44s3.77,0,4.06,1.16a3,3,0,0,1-2.15,3.83C386.82,176.83,384.79,175.64,384.59,174.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,176.32c2.55-.81,3.58-9.5,3.58-9.5s.1,3.67.78,3.56,3.34-5.18,3.55-8.76a28,28,0,0,0,6.62,3c3.3.87,6.9.54,6.89,0-.06-1.65-1.7-5.91-4-7.37a11.67,11.67,0,0,0-11.65-1,11.29,11.29,0,0,0-7.26,8.36C374.59,167.2,375.83,176.62,376.77,176.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.08,177.44s-4.07-4.15-6-2.62,1.67,7.92,4.32,8.44a2.59,2.59,0,0,0,3.19-1.94Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,176.63c-.05,0,0,.06,0,.07,1.88.41,3.07,1.89,4,3.47a1.43,1.43,0,0,0-2.17,0s0,.11.07.09a1.56,1.56,0,0,1,1.81.26,8,8,0,0,1,1.06,1.25c.11.15.38,0,.29-.16l0,0C379.86,179.29,377.59,176.45,375.16,176.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,155.53a20.63,20.63,0,0,0-5.95-1.34c-2.27-.13-7-.24-10.32,3.11-2.77,2.77-2.25,7.62-2.23,8.61s.87,6.88,3.12,8.17,1.76-8.81,4.92-12.38S389.26,155.53,389.26,155.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.26,155.53s-7.29,2.59-10.46,6.17-2.68,13.66-4.93,12.38a4.78,4.78,0,0,1-2-3c.25-3,1.13-7.63,3.37-11,2.1-3.12,5.95-4.89,10.15-5.66A23.29,23.29,0,0,1,389.26,155.53Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,180c0-2.7,2.25-10.08,4.83-14.39s10.84-7.3,12-7.31c2.87,0,3.9.76,4.34.48s-2.66-2.24-3.5-2.66-3.07-1.42-4.31-1.3-8.85,1.4-11.42,4.86-5.87,12.88-5,15.17c.21.55,1,.87,1.28,1.65.38,1,.69,2.22,1.05,2.93S374.87,180.25,374.87,180Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.24,163.73a13.71,13.71,0,0,1-2-1.23,10.24,10.24,0,0,1-1.7-1.59s-.11,0-.08.05a7.79,7.79,0,0,0,1.58,1.81,6.53,6.53,0,0,0,2.1,1.11A.08.08,0,0,0,380.24,163.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.66,177.34a4.23,4.23,0,0,0-.33-.53,3.15,3.15,0,0,1-.29-.65,6.34,6.34,0,0,0-.4-1.28A4.35,4.35,0,0,0,373,174a1.79,1.79,0,0,1-.6-1.06c0-.06-.1-.05-.09,0,.05.81.64,1.35,1,2a8.17,8.17,0,0,1,.46,1.37,2.13,2.13,0,0,0,.79,1.07A.08.08,0,0,0,374.66,177.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.39,174.37c-.27-.29-.57-.54-.82-.86a8.9,8.9,0,0,1-.64-1c-.19-.33-.36-.67-.55-1s-.48-.76-.68-1.16c0-.06-.1,0-.08,0,.21.42.34.88.54,1.3a9.84,9.84,0,0,0,.58,1.06,6.35,6.35,0,0,0,.71.93,3,3,0,0,0,.91.7S375.41,174.39,375.39,174.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.19,171.68a7.49,7.49,0,0,1-1.58-1.55c-.43-.58-.83-1.18-1.22-1.79,0,0-.1,0-.08,0a9.16,9.16,0,0,0,1.07,2,4.34,4.34,0,0,0,.74.8,5.22,5.22,0,0,0,1,.61C376.18,171.78,376.23,171.71,376.19,171.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.08,169.09a2.44,2.44,0,0,1-.76-.67c-.25-.28-.5-.57-.74-.87l-.69-.85a2.64,2.64,0,0,1-.55-1c0-.05-.09,0-.08,0a2.63,2.63,0,0,0,.38,1,7.44,7.44,0,0,0,.68,1,9.59,9.59,0,0,0,.81.88,1.72,1.72,0,0,0,.91.53A.06.06,0,0,0,377.08,169.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,165.85a10.27,10.27,0,0,1-.78-.7c-.24-.24-.48-.5-.71-.76s-.49-.55-.71-.84a0,0,0,0,0-.08,0,7.34,7.34,0,0,0,.57.94,6.17,6.17,0,0,0,.7.82,7.86,7.86,0,0,0,.8.73,2.74,2.74,0,0,0,.91.55.07.07,0,0,0,.07-.1A6.32,6.32,0,0,0,377.63,165.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.19,162.07c-.29-.31-.57-.62-.88-.9a12.93,12.93,0,0,0-1-.81,11.24,11.24,0,0,0-2.18-1.26s-.09,0-.05.07c1.35,1,2.73,2,4.07,3A0,0,0,0,0,382.19,162.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.66,159.66a5.71,5.71,0,0,0-1-.81,12.68,12.68,0,0,0-2.39-1.12c-.06,0-.1.05,0,.08.72.42,1.46.82,2.16,1.28a9,9,0,0,1,1,.72c.32.26.57.59.88.86,0,0,.07,0,.06,0A3.19,3.19,0,0,0,383.66,159.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.82,158.45a5.72,5.72,0,0,0-.9-.8,6.85,6.85,0,0,0-2-1c-.05,0-.08.06,0,.08a13.45,13.45,0,0,1,1.94,1.22c.31.23.6.47.9.72a10.52,10.52,0,0,0,.87.76s.05,0,0,0A6.22,6.22,0,0,0,385.82,158.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.34,157c-.29-.21-.6-.4-.91-.59a3.32,3.32,0,0,0-1-.46s-.07.05,0,.08c.58.4,1.15.81,1.72,1.22a9,9,0,0,1,1.36,1.4s.06,0,.05,0A3.44,3.44,0,0,0,387.34,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.33,156.43a5.52,5.52,0,0,0-1.87-1s-.08.06,0,.08a6.65,6.65,0,0,1,1.71,1.12,9.47,9.47,0,0,1,1.4,1.5,0,0,0,0,0,.06,0A4.65,4.65,0,0,0,389.33,156.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.05,157.45a2.94,2.94,0,0,0-.26-.39,4.23,4.23,0,0,0-.65-.69,9.7,9.7,0,0,0-1.6-1.07c-.05,0-.09,0,0,.08a7.83,7.83,0,0,1,1.51,1.11,6.48,6.48,0,0,1,.62.67c.1.12.18.24.27.37a2.31,2.31,0,0,0,.25.36s.08,0,.07,0A1.05,1.05,0,0,0,392.05,157.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.68,157.49a7.27,7.27,0,0,0-.54-.57,5.57,5.57,0,0,0-.59-.5c-.22-.16-.44-.31-.64-.47a0,0,0,1,0-.06.07,5.07,5.07,0,0,1,.61.52l.54.53.54.53a7.14,7.14,0,0,0,.55.55,0,0,0,0,0,.05-.05A3.37,3.37,0,0,0,393.68,157.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,199.38a33.64,33.64,0,0,0,.8-5.07c-.15-.7-3.53-.34-6.3-1.37s-8-4.07-8.59-4.07-1,5.44-1,5.44,5.64,11,10.44,10.78S393.12,199.38,393.12,199.38Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,194.74a3.26,3.26,0,0,1-.44,2.48,3.08,3.08,0,0,1,0-1.28A3.13,3.13,0,0,1,392.93,194.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.65,194.49a3.33,3.33,0,0,1-.43,2.49,3,3,0,0,1,0-1.29A3.17,3.17,0,0,1,390.65,194.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.58,193.93a3.33,3.33,0,0,1-.43,2.49,3.33,3.33,0,0,1,.43-2.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.53,193.25a3.33,3.33,0,0,1-.43,2.49,3.33,3.33,0,0,1,.43-2.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.3,192.37a3.33,3.33,0,0,1-.43,2.49,3,3,0,0,1,0-1.29A3.11,3.11,0,0,1,384.3,192.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.29,191.47a3.27,3.27,0,0,1-.44,2.49,3.27,3.27,0,0,1,.44-2.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.22,190.43a3,3,0,0,1,0,1.29,2.92,2.92,0,0,1-.46,1.19,3.08,3.08,0,0,1,0-1.28A3.11,3.11,0,0,1,380.22,190.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378,194.32a41.72,41.72,0,0,0,5.12,7.54c.3.09.61.17.92.23a46.93,46.93,0,0,0,8.12.93,7.37,7.37,0,0,0,.95-3.64s.15-.65.31-1.49a52.18,52.18,0,0,1-8.31-.78c-2.14-.46-4.69-2-7-3.78C378,193.92,378,194.32,378,194.32Z",
    style: {
      fill: "#030402",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.45,206.17c-1.57,14-1.88,42.47,6.39,49,8,6.32,35.22-20.91,40.74-26.46,2.27-2.28-11.59-23.33-14.29-21.21-5.94,4.66-16.93,18-17.34,17.92s-3-10.79-5.9-21.25C375.78,189,371.58,196.1,370.45,206.17Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.26,187.43c2.77,1.23,1.46,4.08,1.46,4.08a5.66,5.66,0,0,1,3.86.15c2.12,1,1.52,4.73,1.52,4.73a7,7,0,0,1,4,.8c1.94,1.14,1.87,5,1.87,5a6.19,6.19,0,0,1,3.12,2.94c1.6,3.61-1.74,8.62-3.89,11.79-3.19,4.71-11.09,10.27-12.67,11.79L397,215.35s5.62-16.84,8.42-20.41S415.52,186.22,418.26,187.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.29,191.44c-3.43,2.4-6,5.68-8.69,8.81-.06.07,0,.17.11.1,2.67-3.15,5.93-5.73,8.72-8.76C419.5,191.51,419.39,191.38,419.29,191.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.79,196.28a11,11,0,0,0-1.91,2.12c-.63.8-1.24,1.61-1.83,2.42q-1.8,2.46-3.47,5c-.05.08.05.17.11.1,1.19-1.63,2.41-3.24,3.68-4.81.63-.79,1.27-1.57,1.91-2.35a13.18,13.18,0,0,0,1.72-2.29A.15.15,0,0,0,424.79,196.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,202.28a7.53,7.53,0,0,0-1.62,2c-.53.76-1.06,1.51-1.6,2.26-1.08,1.5-2.15,3-3.28,4.46-.06.07,0,.16.11.09,1.15-1.48,2.33-2.94,3.47-4.43.56-.73,1.11-1.47,1.66-2.2a7.22,7.22,0,0,0,1.34-2.13S431,202.26,431,202.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.16,213.09l19.32,20.32s-24.05,21.33-34.25,22.85-11.05-18.56-11.67-23c-.45-3.15-.57-22.9,1.31-31.49s5.38-9.74,8.85.22,6.2,22.49,6.55,22.19S396.16,213.09,396.16,213.09Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.87,201.81c.08-.37.16-.73.25-1.06a36.18,36.18,0,0,0,5.54,3.48,14.13,14.13,0,0,0,4.13,1c.55,1.74,1.08,3.51,1.56,5.24a23,23,0,0,1-7.83-1.58,33.23,33.23,0,0,1-4.35-2.54A45.57,45.57,0,0,1,370.87,201.81Zm-1.48,16a26.32,26.32,0,0,0,5.66.59,32.57,32.57,0,0,0,9.14-1.35c-.4-1.51-.86-3.18-1.35-4.92a25.2,25.2,0,0,1-13.21.49C369.53,214.34,369.44,216.09,369.39,217.82Zm-.11,6.51c0,1.92,0,3.66.06,5.11a28.71,28.71,0,0,0,12.77-3.55,34.35,34.35,0,0,0,3.83-2.39c-.27-.89-.71-2.54-1.27-4.65-.06-.22-.12-.45-.19-.68C382.64,219.71,376.74,224.09,369.28,224.33Zm1.56,18.6a41.26,41.26,0,0,0,1.39,5.41c6.07-4.47,10.39-11.36,13.31-17.56A81.1,81.1,0,0,0,389,222c.15-.48.29-.93.43-1.34-.24.26-.47.53-.7.77-1.35,1.53-2.37,2.67-2.48,2.76s-.17-.21-.32-.71h0c-.27-.89-.71-2.54-1.27-4.65-.56,1.83-1.41,4.3-2.56,7C379.74,231.56,376.06,238.38,370.84,242.93Zm10.92,13.24a24.56,24.56,0,0,0,6-2.38c1.86-7.82,2.74-19.95,3.12-27.5.17-3.29.24-5.71.27-6.52l-.9,0c-.28.31-.57.63-.83.94s-.47.53-.7.77c-1.35,1.53-2.37,2.67-2.48,2.76s-.17-.21-.32-.71c-.1,2.14-.23,4.62-.41,7.27C384.9,240.21,383.72,251.62,381.76,256.17Zm5.8-33.33a5.85,5.85,0,0,1,.36.52c.74,1.06,1.63,2.38,2.61,3.86,3.43,5.18,7.89,12.39,10.32,18,1.44-1.07,2.83-2.14,4.16-3.18-4-8.64-11.28-19.37-14-23.19-1.26,1.42-2.5,2.82-3.4,3.82l0,0A.54.54,0,0,1,387.56,222.84Zm4.93-5.59c3.17,3.75,11.44,13.72,16.3,21.82l3.95-3.29c-5.46-8.9-14.06-19.15-16.84-22.39Z",
    style: {
      fill: "#030402",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.13,223.9a28.47,28.47,0,0,0-2,5.16,49,49,0,0,0-1.2,5.18s.08,0,.09,0c.46-1.72,1.1-3.45,1.65-5.17s1.28-3.45,1.73-5.16C386.45,223.79,386.18,223.79,386.13,223.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.39,217.71c.14,3.23.25,14.48.61,17.67a72.13,72.13,0,0,0,1.58,9.5,32,32,0,0,0,1.51,4.52,16,16,0,0,0,2.34,4.07,6.16,6.16,0,0,0,3.79,2.26,9.73,9.73,0,0,0,4.53-.6,40.55,40.55,0,0,0,8.39-4.52c2.68-1.77,5.29-3.65,7.9-5.55s5.19-3.82,7.74-5.78,5.13-3.92,7.67-5.91v.08l-1.23-1.37,1.31,1.29,0,0,0,0q-3.66,3.18-7.41,6.24t-7.6,6q-3.86,2.94-7.87,5.66a39.61,39.61,0,0,1-8.58,4.69,10.47,10.47,0,0,1-5,.59,6.35,6.35,0,0,1-2.42-.91,8.36,8.36,0,0,1-1.91-1.69,16.74,16.74,0,0,1-2.43-4.31,27.54,27.54,0,0,1-1.45-4.68C368.6,234.5,369.31,224.16,369.39,217.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.62,207.92c.42,1.26.8,2.53,1.2,3.8l1.14,3.81c.77,2.53,1.47,5.1,2.26,7.61l.15.46.08.22,0,.1,0,0h0l0,0a.37.37,0,0,0-.22-.08h-.05l-.09,0,0,0s0,0,0,0h0l.07-.07.17-.16.34-.36c.45-.47.9-1,1.35-1.45l2.68-2.93,2.7-2.92,2.74-2.89,0,0,0,0,.38.45-.43-.41h.05c-.82,1-1.66,2.08-2.5,3.11l-2.55,3.05c-.85,1-1.73,2-2.6,3-.44.5-.89,1-1.35,1.48l-.34.37-.19.18-.11.1,0,0,0,0-.06,0-.14,0h-.08a.42.42,0,0,1-.24-.09l-.05-.06h0l0,0,0,0,0-.08-.05-.13-.09-.25-.16-.48c-.78-2.55-1.46-5.11-2.1-7.69l-.94-3.86C382.19,210.51,381.88,209.22,381.62,207.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.8,229.6c-2.2-2.35-4.39-4.71-6.68-7-1.31-1.29-2.6-2.58-3.92-3.85-.05-.05-.14,0-.09.08,2.12,2.44,4.25,4.88,6.48,7.22s4.42,4.68,6.67,7c1.28,1.31,2.6,2.57,4,3.8a0,0,0,0,0,0,0C407.23,234.32,405,232,402.8,229.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.49,210.64a20.2,20.2,0,0,1,.23,2.33,20.45,20.45,0,0,1,0,2.35,20.2,20.2,0,0,1-.23-2.33A20.45,20.45,0,0,1,383.49,210.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lightings--inject-75"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "406.71 155.33 415.72 142.42 420.15 146.93 428.27 137.2 432.91 142.06 419.74 150.54 416.21 146.14 406.71 155.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.84 162.51 416.27 159.73 416.27 163.7 425.3 164.31 425.38 168.55 413.27 166.35 414.23 162.48 403.84 162.51",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.68 155.32 398.76 143.37 403.02 143.89 402.93 134.14 407.67 133.63 404.98 146.25 401.19 145.54 399.68 155.32",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc401Error);
export default __webpack_public_path__ + "static/media/ic-401-error.7b3ff005a1c84fea40bac9dbdafa74c2.svg";
export { ForwardRef as ReactComponent };